import { api_configuration } from "../../common";
import {
	jsdate_2_julian_date,
	jsdate_2_julian_datetime,
	julian_datetime_2_gregorian_datetime,
	julian_datetime_2_js_date,
	julian_date_2_js_date,
	parseHtmlDate,
} from "../calendar/conversion";
import { translate } from "../front/translate";
import { DatastoreProxy } from "../interface/DatastoreProxy";
import { login, logout } from "../state 2 interface/authentication";
import {
	evaluateNumericalTypeFilter,
	evaluateNumericalTypeProperty,
	initializedNumericalTypeProperties,
} from "../state 2 interface/numericalTypeProperties";
import { getReferencedNode } from "../state/ResolveStatus";
import { serializeHours, serializeMinutes, serializeSeconds } from "../state 2 interface/serializeNumber";
import { evaluateStyle, initializedStyle } from "../state 2 interface/style";
import { updateTodo } from "../state 2 interface/todos";
import { cancelAction, finishAction, reinitializeOperation, continueAction } from "../state/actions";
import { client_state, getApplicationName, main } from "../state/ClientState";
import { switchOff, switchOn } from "../state/editMode";
import { copyPasswordTokenToClipboard, mailPasswordToken, resetPassword } from "../state/password";
import { deselectEntry, selectEntry } from "../state/selection";
import { registerQueryEntry, registerCollectionEntries } from "../state/registerClientState";
import { ensure } from "../validation";
import { ClientBindings, Formatters, Transformers } from "./ClientBindings";
import ImplementationVisitorContext from "./ImplementationVisitorContext";
import select_candidate from "./instructions/select_candidate";
import { makeNumberConverter } from "./number_converter";
import to_color from "./to_color";
import { openViewContext } from "./view_context";
import parserNumber = require("../front 2 state/parseNumber");
import csr = api_configuration.types.client_state.alan_api;
import save = require("./instructions/save");
import add = require("./instructions/add");
import open = require("./instructions/open");
import update = require("./instructions/update");
import execute = require("./instructions/execute");
import duplicate = require("./instructions/duplicate");
import deeplink = require("./instructions/deeplink");
import reports = require("./instructions/reports");
import discard = require("./instructions/discard");
import messages = require("../front/messages");
import reQuery = require("../state 2 interface/reQuery");
import queryFilter = require("./instructions/queryFilter");
import fileUpload = require("./instructions/fileUpload");
import cancel = require("./instructions/cancel");
import { deleteCollectionEntry, deleteQueryEntry } from "./instructions/delete";
import csv_import = require("./instructions/csv_import");
import Window = require("../widgets/dom/Window");
import { iGraph } from "../state/Graph";
import DestructorTree from "../DestructorTree";
import { deleteFromFilesResource } from "../interface/FilesResourceProxy";
import { addLocalEntry } from "../state/addClientState";
import { startOperation } from "../state/operations";
import { isPasswordProperty } from "../state/password";
import { referencesResolved } from "../state 2 interface/referenceResolver";
import * as expressions from "../state/expressions";
import ReferenceCounter from "../ReferenceCounter";
import { iReference } from "../state/Reference";
import * as Rule from "../state/Rule";
import onSynchronized from "./instructions/onSynchronized";
import openLandingPage from "../front/openLandingPage";
import * as Status from "../Status";
import { sendFeedback } from "../error-logging";
import { onScalarValue } from "../../../../../stream";
import { iText } from "../state/Text";
import { iCollection } from "../state/Collection";
import { iQuery } from "../state/Query";
import { iStategroup, iState } from "../state/Stategroup";
import { checkEntryPermission } from "../state 2 interface/permissions";

export const binding: ClientBindings = {
	collection: {
		properties: {
			"amount of entries": {
				onContext: (implementation_context, destructor) => {
					const collection = ensure(implementation_context.current_binding_context, csr.Ccollection);
					const subscription = iCollection(collection).amountOfEntries.subscribe({ update: () => undefined });
					destructor.onDestroy(() => {
						if (collection.destroyed) return;
						iCollection(collection).amountOfEntries.unsubscribe(subscription);
					});
					return implementation_context;
				},
			},
			"is empty": {
				onContext: (implementation_context, destructor) => {
					const collection = ensure(implementation_context.current_binding_context, csr.Ccollection);
					const subscription = iCollection(collection).isEmpty.subscribe({ update: () => undefined });
					destructor.onDestroy(() => {
						if (collection.destroyed) return;
						iCollection(collection).isEmpty.unsubscribe(subscription);
					});
					return implementation_context;
				},
				states: {
					no: {
						binding: {
							properties: {
								size: {
									states: {
										multiple: { binding: { properties: {} } },
										single: { binding: { properties: {} } },
									},
								},
							},
						},
					},
					yes: { binding: { properties: {} } },
				},
			},
			"can create entry": {
				onContext: (implementation_context, destructor) => {
					const collection = ensure(implementation_context.current_binding_context, csr.Ccollection);
					const subscription = iCollection(collection).canCreateEntry.subscribe({ update: () => undefined });
					destructor.onDestroy(() => {
						if (collection.destroyed) return;
						iCollection(collection).canCreateEntry.unsubscribe(subscription);
					});
					return implementation_context;
				},
				states: {
					no: {
						binding: {
							properties: {},
						},
					},
					yes: {
						binding: {
							properties: {},
							instruction_handlers: {
								"add entry": (implementation_context) => {
									const client_state = ensure(
										implementation_context.current_binding_context,
										csr.Cyes__can_create_entry__collection
									);
									add.addCollectionEntry(client_state.parent);
								},
								"add entry with key": (implementation_context, key) => {
									const client_state = ensure(
										implementation_context.current_binding_context,
										csr.Cyes__can_create_entry__collection
									);
									add.addCollectionEntry(client_state.parent, key);
								},
							},
						},
					},
				},
			},
			"can download files": {
				states: {
					no: { binding: { properties: {} } },
					yes: {
						binding: {
							properties: {},
							instruction_handlers: {
								"download all files": (implementation_context) => {
									const client_state = ensure(
										implementation_context.current_binding_context,
										csr.Cyes__can_download_files__collection
									);
									fileUpload.downloadFiles(client_state.parent);
								},
							},
						},
					},
				},
			},
			"is editable": {
				onContext: (implementation_context, destructor) => {
					const collection = ensure(implementation_context.current_binding_context, csr.Ccollection);
					const subscription = iCollection(collection).canCreateEntry.subscribe({ update: () => undefined });
					destructor.onDestroy(() => {
						if (collection.destroyed) return;
						iCollection(collection).canCreateEntry.unsubscribe(subscription);
					});
					return implementation_context;
				},
				states: {
					no: {
						binding: {
							properties: {},
						},
					},
					yes: {
						binding: {
							properties: {
								"edit mode": {
									states: {
										off: {
											binding: {
												properties: {},
												instruction_handlers: {
													"switch on": (implementation_context) => {
														const client_state = ensure(
															implementation_context.current_binding_context,
															csr.Coff__edit_mode__yes__is_editable__collection
														);
														client_state.parent.properties.edit_mode.set("on", {});
														client_state.parent.parent.properties.entries.forEach((entry) =>
															switchOn(entry.properties.node)
														);
													},
												},
											},
										},
										on: {
											binding: {
												properties: {},
												instruction_handlers: {
													"switch off": (implementation_context) => {
														const client_state = ensure(
															implementation_context.current_binding_context,
															csr.Con__edit_mode__yes__is_editable__collection
														);
														client_state.parent.properties.edit_mode.set("off", {});
														client_state.parent.parent.properties.entries.forEach((entry) =>
															switchOff(entry.properties.node)
														);
													},
												},
											},
										},
									},
								},
							},
						},
					},
				},
			},
			entries: {
				onContext: (implementation_context, destructor) => {
					const collection = ensure(implementation_context.current_binding_context, csr.Ccollection);
					registerCollectionEntries(collection, destructor);
					return implementation_context;
				},
				entry: {
					binding: {
						properties: {},
						bindings: {
							entry: (implementation_context) => implementation_context,
						},
					},
				},
			},
			"is valid": {
				states: {
					no: {
						binding: {
							properties: {
								"entries are invalid": {
									states: {
										no: {
											binding: {
												properties: {},
											},
										},
										yes: {
											binding: {
												properties: {},
											},
										},
									},
								},
								"cardinality constraint violation": {
									states: {
										no: {
											binding: {
												properties: {},
											},
										},
										yes: {
											binding: {
												properties: {},
											},
										},
									},
								},
							},
						},
					},
					yes: {
						binding: {
							properties: {},
						},
					},
				},
			},
			modified: {
				states: {
					no: {
						binding: {
							properties: {},
						},
					},
					yes: {
						binding: {
							properties: {},
						},
					},
				},
			},
			"has ordered graphs": {
				states: {
					no: {
						binding: {
							properties: {},
						},
					},
					yes: {
						binding: {
							properties: {},
						},
					},
				},
			},
			"last created entry": {
				states: {
					entry: {
						binding: {
							properties: {},
							bindings: {
								entry: (implementation_context) => {
									const client_state = ensure(
										implementation_context.current_binding_context,
										csr.Centry__last_created_entry
									);
									return implementation_context.changeState({
										new_binding_context: client_state.properties.entry.ref,
									});
								},
							},
						},
					},
					none: { binding: { properties: {} } },
				},
			},
		},
	},
	entry: {
		properties: {},
		bindings: {
			entity: (implementation_context) => {
				const client_state = ensure(implementation_context.current_binding_context, csr.Centries__collection);
				return implementation_context.changeState({ new_binding_context: client_state.properties.node });
			},
			style: (implementation_context) => {
				const client_state = ensure(implementation_context.current_binding_context, csr.Centries__collection);
				const style = initializedStyle(client_state.properties.style);
				const ui = client_state.parent.inferences.collection_type().properties.ui;
				switch (ui.properties.has_style.state.name) {
					case "no":
						break;
					case "yes": {
						const $ = ui.properties.has_style.state.node;
						evaluateStyle(style, $.properties.style_expression, client_state.properties.node);
						break;
					}
					default:
						unexpectedState(ui.properties.has_style.state);
				}
				return implementation_context.changeState({ new_binding_context: style });
			},
		},
	},
	"joined entry": {
		properties: {},
		bindings: {
			entity: (implementation_context) => {
				const client_state = ensure(implementation_context.current_binding_context, csr.Centries__collection);
				return implementation_context.changeState({ new_binding_context: client_state.properties.node });
			},
			style: (implementation_context) => {
				const client_state = ensure(implementation_context.current_binding_context, csr.Centries__collection);
				const style = initializedStyle(client_state.properties.style);
				const ui = client_state.parent.inferences.collection_type().properties.ui;
				switch (ui.properties.has_style.state.name) {
					case "no":
						break;
					case "yes": {
						const $ = ui.properties.has_style.state.node;
						evaluateStyle(style, $.properties.style_expression, client_state.properties.node);
						break;
					}
					default:
						unexpectedState(ui.properties.has_style.state);
				}
				return implementation_context.changeState({ new_binding_context: style });
			},
		},
	},
	join: {
		properties: {
			"amount of entries": {},
			"is empty": {
				states: {
					no: {
						binding: {
							properties: {
								size: {
									states: {
										multiple: { binding: { properties: {} } },
										single: { binding: { properties: {} } },
									},
								},
							},
						},
					},
					yes: { binding: { properties: {} } },
				},
			},
			"joined collection": {
				states: {
					resolved: {
						binding: {
							properties: {},
							bindings: {
								collection: (implementation_context) => {
									const client_state = ensure(
										implementation_context.current_binding_context,
										csr.Cresolved__joined_collection
									);
									return implementation_context.changeState({
										new_binding_context: client_state.properties.collection.ref,
									});
								},
							},
						},
					},
					unresolved: { binding: { properties: {} } },
				},
			},
			entries: {
				entry: {
					binding: {
						properties: {
							"collection entry": {
								states: {
									entry: {
										binding: {
											properties: {},
											bindings: {
												entry: (implementation_context) => {
													const client_state = ensure(
														implementation_context.current_binding_context,
														csr.Centry__collection_entry
													);
													return implementation_context.changeState({
														new_binding_context: client_state.properties.entry.ref,
													});
												},
											},
										},
									},
									none: { binding: { properties: {} } },
								},
							},
							"referenced entry": {
								states: {
									entry: {
										binding: {
											properties: {
												"can create entry": {
													states: {
														no: { binding: { properties: {} } },
														yes: {
															binding: {
																properties: {},
																instruction_handlers: {
																	"add entry to collection": (implementation_context) => {
																		const client_state = ensure(
																			implementation_context.current_binding_context,
																			csr.Cyes__can_create_entry__entry
																		);
																		switch (
																			client_state.parent.properties.entry.ref.properties.key.ref.properties.is_set
																				.state.name
																		) {
																			case "no":
																				break;
																			case "yes": {
																				const $ =
																					client_state.parent.properties.entry.ref.properties.key.ref.properties.is_set
																						.state.node;
																				addLocalEntry(
																					client_state.parent.parent.parent.parent,
																					"user",
																					$.properties.text
																				);
																				break;
																			}
																			default:
																				unexpectedState(
																					client_state.parent.properties.entry.ref.properties.key.ref.properties.is_set
																						.state
																				);
																		}
																	},
																},
															},
														},
													},
												},
											},
											bindings: {
												entry: (implementation_context) => {
													const client_state = ensure(
														implementation_context.current_binding_context,
														csr.Centry__referenced_entry
													);
													return implementation_context.changeState({
														new_binding_context: client_state.properties.entry.ref,
													});
												},
											},
										},
									},
									none: { binding: { properties: {} } },
								},
							},
						},
					},
				},
			},
		},
		bindings: {
			collection: (implementation_context) => {
				const client_state = ensure(implementation_context.current_binding_context, csr.Cyes__joined);
				return implementation_context.changeState({
					new_binding_context: client_state.parent,
				});
			},
		},
	},
	"ordered graph": {
		properties: {
			"is valid": {
				states: {
					no: {
						binding: {
							properties: {},
						},
					},
					yes: {
						binding: {
							properties: {},
						},
					},
				},
			},
		},
		instruction_handlers: {
			"insert before": (implementation_context: ImplementationVisitorContext, value1: string, value2: string) => {
				const client_state = ensure(implementation_context.current_binding_context, csr.Cordered_graphs);
				const collection = client_state.parent.parent;
				const entry_to_move = collection.properties.entries.get(value1);
				const before_entry = collection.properties.entries.get(value2);
				if (entry_to_move !== undefined && before_entry !== undefined) {
					iGraph(client_state).insertBefore(entry_to_move, before_entry);
				}
			},
			"insert after": (implementation_context: ImplementationVisitorContext, value1: string, value2: string) => {
				const client_state = ensure(implementation_context.current_binding_context, csr.Cordered_graphs);
				const collection = client_state.parent.parent;
				const entry_to_move = collection.properties.entries.get(value1);
				const after_entry = collection.properties.entries.get(value2);
				if (entry_to_move !== undefined && after_entry !== undefined) {
					iGraph(client_state).insertAfter(entry_to_move, after_entry);
				}
			},
			"move forward": (implementation_context: ImplementationVisitorContext, value: string) => {
				const ordered_graph = ensure(implementation_context.current_binding_context, csr.Cordered_graphs);
				const collection = ordered_graph.parent.parent;
				const entry = collection.properties.entries.get(value);
				if (entry === undefined) return;
				iGraph(ordered_graph).moveForward(entry);
			},
			"move backward": (implementation_context: ImplementationVisitorContext, value: string) => {
				const ordered_graph = ensure(implementation_context.current_binding_context, csr.Cordered_graphs);
				const collection = ordered_graph.parent.parent;
				const entry = collection.properties.entries.get(value);
				if (entry === undefined) return;
				iGraph(ordered_graph).moveBackward(entry);
			},
			"move to sink": (implementation_context: ImplementationVisitorContext, value: string) => {
				const ordered_graph = ensure(implementation_context.current_binding_context, csr.Cordered_graphs);
				const collection = ordered_graph.parent.parent;
				const entry = collection.properties.entries.get(value);
				if (entry === undefined) return;
				iGraph(ordered_graph).moveToSink(entry);
			},
			"move to source": (implementation_context: ImplementationVisitorContext, value: string) => {
				const ordered_graph = ensure(implementation_context.current_binding_context, csr.Cordered_graphs);
				const collection = ordered_graph.parent.parent;
				const entry = collection.properties.entries.get(value);
				if (entry === undefined) return;
				iGraph(ordered_graph).moveToSource(entry);
			},
		},
	},
	"sort property": {
		properties: {},
	},
	operation: {
		instruction_handlers: {
			reset: (implementation_context) => {
				const client_state = ensure(implementation_context.current_binding_context, csr.Coperation__type__attributes);
				const destructor = DestructorTree.create();
				const operation = startOperation(client_state, destructor);
				// Trigger the executing state so that the defaults will be applied after resetting the node.
				operation.properties.executing.ensure("yes", {
					"can continue": "no",
				});
				reinitializeOperation(operation);
				operation.properties.executing.ensure("no", {
					"last result": "not invoked",
				});
				destructor.destroy();
			},
		},
		bindings: {
			parameters: (implementation_context, destructor) => {
				const client_state = ensure(implementation_context.current_binding_context, csr.Coperation__type__attributes);
				return implementation_context.changeState({
					new_binding_context: startOperation(client_state, destructor).properties.node,
				});
			},
		},
		properties: {
			"is valid": {
				onContext: (implementation_context, destructor) => {
					const client_state = ensure(implementation_context.current_binding_context, csr.Coperation__type__attributes);
					return implementation_context.changeState({
						new_binding_context: startOperation(client_state, destructor),
					});
				},
				states: {
					no: {
						binding: {
							properties: {},
						},
					},
					yes: {
						binding: {
							properties: {},
						},
					},
				},
			},
			executing: {
				onContext: (implementation_context, destructor) => {
					const client_state = ensure(implementation_context.current_binding_context, csr.Coperation__type__attributes);
					return implementation_context.changeState({
						new_binding_context: startOperation(client_state, destructor),
					});
				},
				states: {
					no: {
						binding: {
							properties: {
								"last result": {
									states: {
										"not invoked": { binding: { properties: {} } },
										failure: { binding: { properties: {} } },
										success: { binding: { properties: {} } },
									},
								},
							},
						},
					},
					yes: {
						binding: {
							properties: {
								"can continue": {
									states: {
										no: {
											binding: {
												properties: {},
											},
										},
										yes: {
											binding: {
												instruction_handlers: {
													continue: (implementation_context) => {
														const client_state = ensure(
															implementation_context.current_binding_context,
															csr.Cyes__can_continue
														);
														switch (client_state.parent.parent.parent.properties.type.state.name) {
															case "action":
																continueAction(client_state);
																break;
															case "command":
														}
													},
												},
												properties: {},
											},
										},
									},
								},
							},
						},
					},
				},
			},
			executable: {
				onContext: (implementation_context, destructor) => {
					const client_state = ensure(implementation_context.current_binding_context, csr.Coperation__type__attributes);
					return implementation_context.changeState({
						new_binding_context: startOperation(client_state, destructor),
					});
				},
				states: {
					no: { binding: { properties: {} } },
					yes: {
						binding: {
							instruction_handlers: {
								execute: (implementation_context) => {
									const client_state = ensure(implementation_context.current_binding_context, csr.Cyes__executable);
									switch (client_state.parent.parent.properties.type.state.name) {
										case "action": {
											const view_bindings = implementation_context.model_binding.properties.type
												.cast("action")
												.properties.view_bindings.map((view) => view);
											const can_use_containing_view = implementation_context.model_binding.properties.type
												.cast("action")
												.properties.can_use_containing_view.switch({
													no: false,
													yes: true,
												});
											const view_node_type = implementation_context.model_binding.properties.type
												.cast("action")
												.parent.parent.input.view()
												.properties.node_type.output.result_gui_node()
												.input.application_node();

											return execute.action(
												client_state.parent,
												view_bindings,
												can_use_containing_view,
												view_node_type
											);
										}
										case "command": {
											return execute.command(client_state.parent);
										}
										default:
											unexpectedState(client_state.parent.parent.properties.type.state);
									}
								},
							},
							properties: {},
						},
					},
				},
			},
			type: {
				states: {
					action: { binding: { properties: {} } },
					command: {
						binding: {
							properties: {
								"execute permitted": {
									states: {
										no: { binding: { properties: {} } },
										yes: { binding: { properties: {} } },
									},
								},
							},
						},
					},
				},
			},
		},
	},
	user: {
		properties: {},
		bindings: {
			node: function (implementation_context: ImplementationVisitorContext): ImplementationVisitorContext {
				ensure(implementation_context.current_binding_context, csr.Cnode);
				return implementation_context;
			},
		},
	},
	"engine state": {
		properties: {
			version: {},
			reports: {
				onContext: (implementation_context) => {
					reports.list_reports();
					return implementation_context.changeState({ new_binding_context: client_state });
				},
				entry: {
					binding: {
						properties: {
							definition: {
								states: {
									known: {
										binding: {
											properties: {
												"of type": {},
											},
										},
									},
									unknown: { binding: { properties: {} } },
								},
							},
							permissions: {
								states: {
									"read only": { binding: { properties: {} } },
									writable: {
										binding: {
											properties: {},
											instruction_handlers: {
												"delete template": function (implementation_context: ImplementationVisitorContext) {
													const client_state = ensure(implementation_context.current_binding_context, csr.Cwritable);
													const report_type_name = client_state.parent.properties.definition.switch<string>({
														known: ($) => $.properties.of_type.entry,
														unknown: "unknown",
													});
													if (
														confirm(
															translate("Delete template") +
																" '" +
																client_state.parent.key +
																"' " +
																translate("of type") +
																" '" +
																report_type_name +
																"'?"
														)
													) {
														reports.delete_template(client_state.parent, implementation_context.view_context_node);
													}
												},
											},
										},
									},
								},
							},
						},
					},
				},
			},
			"report types": {
				onContext: (implementation_context) =>
					implementation_context.changeState({ new_binding_context: client_state }),
				entry: {
					binding: {
						properties: {},
						instruction_handlers: {
							"upload template": function (implementation_context: ImplementationVisitorContext, file_event: File) {
								const client_state = ensure(
									implementation_context.current_binding_context,
									csr.Creport_types__client_state
								);
								reports.upload_template(client_state, file_event, implementation_context.view_context_node);
							},
						},
					},
				},
			},
			status: {
				onContext: (implementation_context) =>
					implementation_context.changeState({ new_binding_context: client_state.properties.session }),
				states: {
					authenticated: {
						binding: {
							properties: {
								"anonymous session": {
									states: {
										yes: {
											binding: {
												properties: {},
												instruction_handlers: {
													"log in": () => login(getApplicationName(), DatastoreProxy.instance.connection),
												},
											},
										},
										no: {
											binding: {
												properties: {
													username: {},
													"user found": {
														onContext: (implementation_context, destructor) => {
															const client_state = ensure(
																implementation_context.current_binding_context,
																csr.Cno__anonymous_session
															);
															let counter: ReferenceCounter | undefined = (client_state as any).__reference_counter;
															if (counter === undefined) {
																let user_destructor = new DestructorTree();
																counter = new ReferenceCounter();
																counter.subscribeConditional(
																	(value) => value <= 0,
																	(empty) => {
																		if (empty) {
																			user_destructor.destroy();
																		} else {
																			user_destructor = new DestructorTree();
																			onScalarValue(
																				expressions.dynamicUser()(undefined),
																				(user_node) => {
																					if (Status.isResolved(user_node)) {
																						client_state.root.transact(() => {
																							const user_found = client_state.properties.user_found.ensure("yes", {});
																							(user_found as any).node = user_node;
																						});
																					} else {
																						client_state.properties.user_found.ensure("no", {});
																					}
																				},
																				(scalar, subscription) =>
																					user_destructor.onDestroy(() => {
																						client_state.properties.user_found.ensure("no", {});
																						scalar.unsubscribe(subscription);
																					})
																			);
																		}
																	}
																);
																(client_state as any).__reference_counter = counter;
															}
															counter.add_registration(destructor);
															return implementation_context;
														},
														states: {
															no: { binding: { properties: {} } },
															yes: { binding: { properties: {} } },
														},
													},
												},
												instruction_handlers: {
													logout: function () {
														client_state.properties.session.properties.status.switch({
															authenticated: function () {
																logout(getApplicationName(), DatastoreProxy.instance.connection);
															},
															"not authenticated": undefined,
														});
													},
												},
											},
										},
									},
								},
							},
						},
					},
					"not authenticated": {
						binding: {
							properties: {},
							instruction_handlers: {
								"log in": () => login(getApplicationName(), DatastoreProxy.instance.connection),
							},
						},
					},
				},
			},
			"server connection status": {
				onContext: (implementation_context) =>
					implementation_context.changeState({ new_binding_context: client_state }),
				states: {
					alive: { binding: { properties: {} } },
					dead: { binding: { properties: {} } },
				},
			},
			"network connection status": {
				onContext: (implementation_context) =>
					implementation_context.changeState({ new_binding_context: client_state }),
				states: {
					alive: { binding: { properties: {} } },
					dead: { binding: { properties: {} } },
				},
			},
			"platform family": {
				onContext: (implementation_context) =>
					implementation_context.changeState({ new_binding_context: client_state }),
				states: {
					Android: { binding: { properties: {} } },
					macOS: { binding: { properties: {} } },
					iOS: { binding: { properties: {} } },
					Linux: { binding: { properties: {} } },
					Windows: { binding: { properties: {} } },
					undetermined: { binding: { properties: {} } },
				},
			},
			"browser family": {
				onContext: (implementation_context) =>
					implementation_context.changeState({ new_binding_context: client_state }),
				states: {
					Edge: { binding: { properties: {} } },
					Safari: { binding: { properties: {} } },
					Chromium: { binding: { properties: {} } },
					undetermined: { binding: { properties: {} } },
				},
			},
			"alt key pressed": {
				onContext: (implementation_context) =>
					implementation_context.changeState({ new_binding_context: client_state }),
				states: {
					yes: { binding: { properties: {} } },
					no: { binding: { properties: {} } },
				},
			},
			"ctrl key pressed": {
				onContext: (implementation_context) =>
					implementation_context.changeState({ new_binding_context: client_state }),
				states: {
					yes: { binding: { properties: {} } },
					no: { binding: { properties: {} } },
				},
			},
			"shift key pressed": {
				onContext: (implementation_context) =>
					implementation_context.changeState({ new_binding_context: client_state }),
				states: {
					yes: { binding: { properties: {} } },
					no: { binding: { properties: {} } },
				},
			},
			"meta key pressed": {
				onContext: (implementation_context) =>
					implementation_context.changeState({ new_binding_context: client_state }),
				states: {
					yes: { binding: { properties: {} } },
					no: { binding: { properties: {} } },
				},
			},
			"toggle key pressed": {
				onContext: (implementation_context) =>
					implementation_context.changeState({ new_binding_context: client_state }),
				states: {
					yes: { binding: { properties: {} } },
					no: { binding: { properties: {} } },
				},
			},
			"logo url": {},
			"logo-sideways url": {},
			"selected language": {},
			languages: {
				onContext: (implementation_context) =>
					implementation_context.changeState({ new_binding_context: client_state }),
				entry: {
					binding: {
						properties: {
							label: {},
						},
						instruction_handlers: {
							"select language": function (implementation_context: ImplementationVisitorContext) {
								const gui_state = ensure(
									implementation_context.current_binding_context,
									api_configuration.types.client_state.alan_api.Clanguages
								);
								client_state.set_selected_language(gui_state.key.entry);
							},
						},
					},
				},
			},
			messages: {
				onContext: (implementation_context) =>
					implementation_context.changeState({ new_binding_context: client_state }),
				entry: {
					binding: {
						properties: {
							type: {
								states: {
									error: { binding: { properties: {} } },
									warning: { binding: { properties: {} } },
									success: { binding: { properties: {} } },
									waiting: { binding: { properties: {} } },
								},
							},
							title: {},
							"has body": {
								states: {
									no: { binding: { properties: {} } },
									yes: {
										binding: {
											properties: {
												body: {},
											},
										},
									},
								},
							},
						},
						instruction_handlers: {
							"remove message": function (implementation_context: ImplementationVisitorContext) {
								const client_state = ensure(implementation_context.current_binding_context, csr.Cmessages);
								messages.removeMessage(client_state.key);
							},
						},
					},
				},
			},
			modules: {
				onContext: (implementation_context) =>
					implementation_context.changeState({ new_binding_context: client_state }),
				entry: {
					binding: {
						properties: {
							name: {},
							"has logo": {
								states: {
									no: { binding: { properties: {} } },
									yes: {
										binding: {
											properties: {
												url: {},
											},
										},
									},
								},
							},
						},
					},
				},
			},
			"has landing page": {
				states: {
					no: { binding: { properties: {} } },
					yes: {
						binding: {
							properties: {},
							instruction_handlers: {
								"open landing page": () => {
									openLandingPage(main);
								},
							},
						},
					},
				},
			},
		},
		instruction_handlers: {
			"send feedback": (_, message) => {
				sendFeedback(message);
			},
			"on synchronized": () => onSynchronized(),
			"add error message": (_implementation_context, title, body) => {
				messages.addRawMessage("error", title, body);
			},
			"add warning message": (_implementation_context, title, body) => {
				messages.addRawMessage("warning", title, body);
			},
			"add success message": (_implementation_context, title, body) => {
				messages.addRawMessage("success", title, body);
			},
		},
	},
	entity: {
		bindings: {
			node: function (implementation_context: ImplementationVisitorContext): ImplementationVisitorContext {
				ensure(implementation_context.current_binding_context, csr.Cnode);
				return implementation_context;
			},
		},
		properties: {
			"can be deleted": {
				states: {
					no: { binding: { properties: {} } },
					yes: {
						binding: {
							properties: {},
							instruction_handlers: {
								delete: (implementation_context) => {
									const client_state = ensure(implementation_context.current_binding_context, csr.Cyes__can_be_deleted);
									deleteCollectionEntry(client_state.parent.input.entity().cast("entry"));
								},
							},
						},
					},
				},
			},
			location: {
				states: {
					remote: {
						binding: {
							properties: {
								initialization: {
									states: {
										"not initialized": { binding: { properties: {} } },
										pending: { binding: { properties: {} } },
										success: { binding: { properties: {} } },
										failure: { binding: { properties: {} } },
									},
								},
							},
						},
					},
					local: {
						binding: {
							properties: {
								"parent location": {
									states: {
										remote: {
											binding: {
												properties: {},
											},
										},
										local: {
											binding: {
												properties: {},
											},
										},
									},
								},
							},
						},
					},
				},
			},
			"is valid": {
				states: {
					no: {
						binding: {
							properties: {},
						},
					},
					yes: {
						binding: {
							properties: {},
						},
					},
				},
			},
			modified: {
				states: {
					no: {
						binding: {
							properties: {},
						},
					},
					yes: {
						binding: {
							properties: {},
						},
					},
				},
			},
			"is editable": {
				onContext: (implementation_context) => {
					const entity = ensure(implementation_context.current_binding_context, csr.Cnode).input.entity();
					return implementation_context.changeState({
						new_binding_context: entity.switch<csr.AlanObject>({
							root: ($) => $,
							entry: ($) => $.parent,
						}),
					});
				},
				states: {
					no: {
						binding: {
							properties: {},
						},
					},
					yes: {
						binding: {
							properties: {},
						},
					},
				},
			},
			"is busy saving": {
				states: {
					no: {
						binding: {
							properties: {},
						},
					},
					yes: {
						binding: {
							properties: {},
						},
					},
				},
			},
			"is busy discarding": {
				states: {
					no: {
						binding: {
							properties: {},
						},
					},
					yes: {
						binding: {
							properties: {},
						},
					},
				},
			},
		},
		instruction_handlers: {
			cancel: async function (implementation_context: ImplementationVisitorContext) {
				const client_state = ensure(implementation_context.current_binding_context, csr.Cnode);
				return cancel.entry(client_state);
			},
			duplicate: (implementation_context, view) => {
				const client_state = ensure(implementation_context.current_binding_context, csr.Cnode);
				duplicate.entity(client_state, view.parent.properties.view.ref, view.properties.window.ref);
			},
			"open view": (implementation_context, view) => {
				openViewContext(view.parent, implementation_context);
			},
			save: function (implementation_context: ImplementationVisitorContext) {
				const client_state = ensure(implementation_context.current_binding_context, csr.Cnode);
				return save.entity(client_state);
			},
			"save all": function (implementation_context: ImplementationVisitorContext) {
				const client_state = ensure(implementation_context.current_binding_context, csr.Cnode);
				return save.entity(client_state, true);
			},
			"add entry": (implementation_context: ImplementationVisitorContext, view) => {
				const client_state = ensure(implementation_context.current_binding_context, csr.Cnode);
				add.entryFromEntity(client_state, view.parent.properties.view.ref, view.properties.window.ref);
			},
			discard: function (implementation_context: ImplementationVisitorContext) {
				const client_state = ensure(implementation_context.current_binding_context, csr.Cnode);
				return discard.entity(client_state);
			},
		},
	},
	window: {
		instruction_handlers: {
			"close all views": function (implementation_context: ImplementationVisitorContext) {
				const client_state = ensure(implementation_context.current_binding_context, csr.Cwindows);
				client_state.properties.open_views.forEach(($) => {
					cancel.entry($.properties.view_context.properties.has_steps.state.node.output.result_node());
					Window.getWindowInstance(client_state.key.ref.key).close_view($);
				});
			},
			"close all but active view": (implementation_context: ImplementationVisitorContext) => {
				const client_state = ensure(implementation_context.current_binding_context, csr.Cwindows);
				client_state.properties.open_views.forEach(($) => {
					switch ($.properties.is_active_view.state.name) {
						case "no":
							cancel.entry($.properties.view_context.properties.has_steps.state.node.output.result_node());
							Window.getWindowInstance(client_state.key.ref.key).close_view($);
							break;
						case "yes":
					}
				});
			},
		},
		properties: {
			"open views": {
				entry: {
					binding: {
						bindings: {
							entity: function (implementation_context: ImplementationVisitorContext): ImplementationVisitorContext {
								const client_state = ensure(implementation_context.current_binding_context, csr.Copen_views);
								const new_client_state = client_state.properties.view_context.output.result_node();
								return implementation_context.changeState({ new_binding_context: new_client_state });
							},
						},
						instruction_handlers: {
							activate: function (implementation_context: ImplementationVisitorContext) {
								const client_state = ensure(implementation_context.current_binding_context, csr.Copen_views);
								Window.getWindowInstance(client_state.parent.key.ref.key).activate_view(client_state);
							},
							"close view": function (implementation_context: ImplementationVisitorContext) {
								const client_state = ensure(implementation_context.current_binding_context, csr.Copen_views);
								Window.getWindowInstance(client_state.parent.key.ref.key).close_view(client_state);
							},
						},
						properties: {
							"is active view": {
								states: {
									no: {
										binding: {
											properties: {},
										},
									},
									yes: {
										binding: {
											properties: {},
										},
									},
								},
							},
							"is entry view": {
								states: {
									no: {
										binding: {
											properties: {
												title: {},
											},
										},
									},
									yes: {
										binding: {
											properties: {
												"entry path": {},
												"entry key": {},
											},
										},
									},
								},
							},
						},
					},
				},
			},
		},
	},
	file: {
		properties: {
			"backend known": {
				states: {
					no: {
						binding: {
							properties: {},
						},
					},
					yes: {
						binding: {
							properties: {
								"is readable": {
									states: {
										no: {
											binding: {
												properties: {},
											},
										},
										yes: {
											binding: {
												properties: {
													extension: {},
													token: {},
												},
												instruction_handlers: {
													revert: function (implementation_context: ImplementationVisitorContext) {
														const client_state = ensure(
															implementation_context.current_binding_context,
															csr.Cyes__is_readable__yes__backend_known__file
														);
														update.file_toBackendValue(client_state);
													},
												},
											},
										},
									},
								},
							},
						},
					},
				},
			},
			"is editable": {
				states: {
					no: {
						binding: {
							properties: {},
						},
					},
					yes: {
						binding: {
							properties: {
								modified: {
									states: {
										no: {
											binding: {
												properties: {},
											},
										},
										yes: {
											binding: {
												properties: {
													extension: {},
													"upload status": {
														states: {
															"not uploaded": { binding: { properties: {} } },
															uploading: { binding: { properties: {} } },
															done: {
																binding: {
																	properties: {
																		token: {},
																	},
																},
															},
														},
													},
												},
											},
										},
									},
								},
								"edit mode": {
									states: {
										off: {
											binding: {
												properties: {},
												instruction_handlers: {
													"switch on": (implementation_context) => {
														const client_state = ensure(
															implementation_context.current_binding_context,
															csr.Coff__edit_mode__yes__is_editable__file
														);
														client_state.parent.properties.edit_mode.set("on", {});
													},
												},
											},
										},
										on: {
											binding: {
												properties: {},
												instruction_handlers: {
													"switch off": (implementation_context) => {
														const client_state = ensure(
															implementation_context.current_binding_context,
															csr.Con__edit_mode__yes__is_editable__file
														);
														client_state.parent.properties.edit_mode.set("off", {});
													},
												},
											},
										},
									},
								},
							},
							instruction_handlers: {
								"delete file": (implementation_context) => {
									const client_state = ensure(
										implementation_context.current_binding_context,
										csr.Cyes__is_editable__file
									);
									switch (client_state.parent.properties.is_set.state.name) {
										case "yes": {
											return deleteFromFilesResource(client_state.parent.properties.is_set.state.node.properties.token);
										}
										case "no":
											break;
									}
									return undefined;
								},
							},
						},
					},
				},
			},
			"is valid": {
				states: {
					no: {
						binding: {
							properties: {
								"not set": {
									states: {
										no: { binding: { properties: {} } },
										yes: { binding: { properties: {} } },
									},
								},
								"extension not valid": {
									states: {
										no: { binding: { properties: {} } },
										yes: {
											binding: {
												properties: {
													pattern: {},
												},
											},
										},
									},
								},
							},
						},
					},
					yes: {
						binding: {
							properties: {},
						},
					},
				},
			},
			"is set": {
				states: {
					no: { binding: { properties: {} } },
					yes: {
						binding: {
							properties: {
								extension: {},
								token: {},
							},
						},
					},
				},
			},
		},
		instruction_handlers: {
			"add single file": function (implementation_context: ImplementationVisitorContext, file_event: File) {
				const client_state = ensure(implementation_context.current_binding_context, csr.Cfile__type__property);
				client_state.properties.is_editable.switch({
					no: function () {
						messages.addMessage("warning", "Cannot upload file", {
							body: "The file can not be uploaded because the property is not editable.",
						});
					},
					yes: function ($) {
						fileUpload.addFileUploadToQueue($, file_event);
					},
				});
			},
			"download file": function (implementation_context: ImplementationVisitorContext) {
				const client_state = ensure(implementation_context.current_binding_context, csr.Cfile__type__property);
				fileUpload.downloadFile(client_state);
			},
		},
	},
	group: {
		bindings: {
			node: function (implementation_context: ImplementationVisitorContext): ImplementationVisitorContext {
				const client_state = ensure(implementation_context.current_binding_context, csr.Cgroup__type__property);
				return implementation_context.changeState({ new_binding_context: client_state.properties.node });
			},
		},
		properties: {},
	},
	node: {
		bindings: {
			entity: function (implementation_context: ImplementationVisitorContext): ImplementationVisitorContext {
				const client_state = ensure(implementation_context.current_binding_context, csr.Cnode);
				return implementation_context.switchBindingContext(client_state.input.entity().input.node());
			},
			view: (implementation_context) =>
				implementation_context.switchBindingContext(implementation_context.get_client_view()),
		},
		properties: {
			location: {
				states: {
					remote: {
						binding: {
							properties: {
								"edit mode": {
									states: {
										off: {
											binding: {
												properties: {},
												instruction_handlers: {
													"switch on": (implementation_context) => {
														const client_state = ensure(
															implementation_context.current_binding_context,
															csr.Coff__edit_mode__remote
														);
														switchOn(client_state.parent.parent);
													},
													"switch off properties": (implementation_context) => {
														const client_state = ensure(
															implementation_context.current_binding_context,
															csr.Coff__edit_mode__remote
														);
														switchOff(client_state.parent.parent);
													},
												},
											},
										},
										on: {
											binding: {
												properties: {},
												instruction_handlers: {
													"switch off": (implementation_context) => {
														const client_state = ensure(
															implementation_context.current_binding_context,
															csr.Con__edit_mode__remote
														);
														switchOff(client_state.parent.parent);
													},
												},
											},
										},
									},
								},
							},
						},
					},
					local: {
						binding: {
							properties: {},
						},
					},
				},
			},
			"is valid": {
				states: {
					no: {
						binding: {
							properties: {},
						},
					},
					yes: {
						binding: {
							properties: {},
						},
					},
				},
			},
			modified: {
				states: {
					no: {
						binding: {
							properties: {},
						},
					},
					yes: {
						binding: {
							properties: {},
						},
					},
				},
			},
			"read permitted": {
				states: {
					no: {
						binding: {
							properties: {},
						},
					},
					yes: {
						binding: {
							properties: {},
						},
					},
				},
			},
			todo: {
				states: {
					no: { binding: { properties: {} } },
					yes: {
						binding: {
							properties: {
								for: {
									onContext: (implementation_context) => {
										const client_state = ensure(implementation_context.current_binding_context, csr.Cyes__todo);
										updateTodo(client_state);
										return implementation_context;
									},
									states: {
										"current user": {
											binding: {
												properties: {
													and: {
														states: {
															"no one else": { binding: { properties: {} } },
															others: { binding: { properties: {} } },
														},
													},
												},
											},
										},
										"someone else": { binding: { properties: {} } },
									},
								},
							},
						},
					},
				},
			},
		},
		instruction_handlers: {
			"open view": (implementation_context, view) => {
				openViewContext(view.parent, implementation_context);
			},
			"refresh queries": function (implementation_context: ImplementationVisitorContext) {
				const node = ensure(implementation_context.current_binding_context, csr.Cnode);
				node.properties.queries.forEach(function ($) {
					// FIXME: refresh only the queries of the current view.
					reQuery.execute($.properties.query);
				});
			},
		},
	},
	number: {
		properties: {
			"backend known": {
				states: {
					no: {
						binding: {
							properties: {},
						},
					},
					yes: {
						binding: {
							properties: {
								"is readable": {
									states: {
										no: {
											binding: {
												properties: {},
											},
										},
										yes: {
											binding: {
												properties: {
													number: {
														onContext: (implementation_context) => {
															const number_property = ensure(
																implementation_context.current_binding_context,
																csr.Cyes__is_readable__yes__backend_known__number
															).parent.parent;
															const numerical_type_properties = initializedNumericalTypeProperties(
																number_property.properties.numerical_type_properties
															);
															evaluateNumericalTypeProperty(
																numerical_type_properties,
																number_property.inferences.number_type(),
																number_property.parent.parent.parent
															);
															return implementation_context.changeState({
																new_number_converter: makeNumberConverter(numerical_type_properties),
															});
														},
													},
												},
												instruction_handlers: {
													revert: function (implementation_context: ImplementationVisitorContext) {
														const client_state = ensure(
															implementation_context.current_binding_context,
															csr.Cyes__is_readable__yes__backend_known__number
														);
														update.number_toBackendValue(client_state.parent.parent);
													},
												},
											},
										},
									},
								},
							},
						},
					},
				},
			},
			"is editable": {
				states: {
					no: {
						binding: {
							properties: {},
						},
					},
					yes: {
						binding: {
							properties: {
								modified: {
									states: {
										no: {
											binding: {
												properties: {},
											},
										},
										yes: {
											binding: {
												properties: {
													number: {
														onContext: (implementation_context) => {
															const number_property = ensure(
																implementation_context.current_binding_context,
																csr.Cyes__modified__yes__is_editable__number
															).parent.parent;
															const numerical_type_properties = initializedNumericalTypeProperties(
																number_property.properties.numerical_type_properties
															);
															evaluateNumericalTypeProperty(
																numerical_type_properties,
																number_property.inferences.number_type(),
																number_property.parent.parent.parent
															);
															return implementation_context.changeState({
																new_number_converter: makeNumberConverter(numerical_type_properties),
															});
														},
													},
												},
											},
										},
									},
								},
								"edit mode": {
									states: {
										off: {
											binding: {
												properties: {},
												instruction_handlers: {
													"switch on": (implementation_context) => {
														const client_state = ensure(
															implementation_context.current_binding_context,
															csr.Coff__edit_mode__yes__is_editable__number
														);
														client_state.parent.properties.edit_mode.set("on", {});
													},
												},
											},
										},
										on: {
											binding: {
												properties: {},
												instruction_handlers: {
													"switch off": (implementation_context) => {
														const client_state = ensure(
															implementation_context.current_binding_context,
															csr.Con__edit_mode__yes__is_editable__number
														);
														client_state.parent.properties.edit_mode.set("off", {});
													},
												},
											},
										},
									},
								},
							},
						},
					},
				},
			},
			"is set": {
				states: {
					no: {
						binding: {
							properties: {},
						},
					},
					yes: {
						binding: {
							properties: {
								number: {
									onContext: (implementation_context) => {
										const number_property = ensure(
											implementation_context.current_binding_context,
											csr.Cyes__is_set__number__type__property
										).parent;
										const numerical_type_properties = initializedNumericalTypeProperties(
											number_property.properties.numerical_type_properties
										);
										evaluateNumericalTypeProperty(
											numerical_type_properties,
											number_property.inferences.number_type(),
											number_property.parent.parent.parent
										);
										return implementation_context.changeState({
											new_number_converter: makeNumberConverter(numerical_type_properties),
										});
									},
								},
							},
						},
					},
				},
			},
			"is valid": {
				states: {
					no: {
						binding: {
							properties: {
								"exceeds maximum": {
									states: {
										no: { binding: { properties: {} } },
										yes: {
											binding: {
												properties: {
													maximum: {
														onContext: (implementation_context) => {
															const number_property = ensure(
																implementation_context.current_binding_context,
																csr.Cyes__exceeds_maximum
															).parent.parent;
															const numerical_type_properties = initializedNumericalTypeProperties(
																number_property.properties.numerical_type_properties
															);
															evaluateNumericalTypeProperty(
																numerical_type_properties,
																number_property.inferences.number_type(),
																number_property.parent.parent.parent
															);
															return implementation_context.changeState({
																new_number_converter: makeNumberConverter(numerical_type_properties),
															});
														},
													},
												},
											},
										},
									},
								},
								"exceeds minimum": {
									states: {
										no: { binding: { properties: {} } },
										yes: {
											binding: {
												properties: {
													minimum: {
														onContext: (implementation_context) => {
															const number_property = ensure(
																implementation_context.current_binding_context,
																csr.Cyes__exceeds_minimum
															).parent.parent;
															const numerical_type_properties = initializedNumericalTypeProperties(
																number_property.properties.numerical_type_properties
															);
															evaluateNumericalTypeProperty(
																numerical_type_properties,
																number_property.inferences.number_type(),
																number_property.parent.parent.parent
															);
															return implementation_context.changeState({
																new_number_converter: makeNumberConverter(numerical_type_properties),
															});
														},
													},
												},
											},
										},
									},
								},
								"not a number": {
									states: {
										no: { binding: { properties: {} } },
										yes: { binding: { properties: {} } },
									},
								},
								"not set": {
									states: {
										no: { binding: { properties: {} } },
										yes: { binding: { properties: {} } },
									},
								},
								"should be positive": {
									states: {
										no: { binding: { properties: {} } },
										yes: { binding: { properties: {} } },
									},
								},
							},
						},
					},
					yes: {
						binding: {
							properties: {},
						},
					},
				},
			},
			unit: {
				onContext: (implementation_context) => {
					const client_state = ensure(implementation_context.current_binding_context, csr.Cnumber__type__property);
					const numerical_type_properties = initializedNumericalTypeProperties(
						client_state.properties.numerical_type_properties
					);
					evaluateNumericalTypeProperty(
						numerical_type_properties,
						client_state.inferences.number_type(),
						client_state.parent.parent.parent
					);
					return implementation_context.changeState({
						new_binding_context: numerical_type_properties,
					});
				},
			},
			decimals: {
				onContext: (implementation_context) => {
					const client_state = ensure(implementation_context.current_binding_context, csr.Cnumber__type__property);
					const numerical_type_properties = initializedNumericalTypeProperties(
						client_state.properties.numerical_type_properties
					);
					evaluateNumericalTypeProperty(
						numerical_type_properties,
						client_state.inferences.number_type(),
						client_state.parent.parent.parent
					);
					return implementation_context.changeState({ new_binding_context: numerical_type_properties });
				},
			},
		},
		instruction_handlers: {
			"set number": function (implementation_context: ImplementationVisitorContext, value) {
				const client_state = ensure(implementation_context.current_binding_context, csr.Cnumber__type__property);
				const numerical_type_properties = initializedNumericalTypeProperties(
					client_state.properties.numerical_type_properties
				);
				evaluateNumericalTypeProperty(
					numerical_type_properties,
					client_state.inferences.number_type(),
					client_state.parent.parent.parent
				);
				update.number(client_state, makeNumberConverter(numerical_type_properties).from(value), "user");
			},
		},
	},
	query: {
		properties: {
			columns: {
				entry: {
					binding: {
						properties: {
							"column type": {
								states: {
									content: {
										binding: {
											properties: {},
										},
									},
									id: {
										binding: {
											properties: {},
										},
									},
								},
							},
							name: {},
							type: {
								states: {
									file: {
										binding: {
											properties: {},
										},
									},
									number: {
										binding: {
											properties: {},
											bindings: {
												"number column": (context) => context,
											},
										},
									},
									reference: {
										binding: {
											properties: {
												"has filter": {
													states: {
														no: {
															binding: {
																properties: {},
															},
														},
														yes: {
															binding: {
																properties: {},
															},
														},
													},
												},
											},
										},
									},
									"state group": {
										binding: {
											properties: {},
											bindings: {
												"stategroup column": (context) => context,
											},
										},
									},
									text: {
										binding: {
											properties: {},
											bindings: {
												"text column": (context) => context,
											},
										},
									},
									widget: {
										binding: {
											properties: {},
										},
									},
								},
							},
						},
					},
				},
				first_entry: (client_state) => {
					const collection_context = ensure(client_state, csr.Cquery__client_state);
					return collection_context.properties.has_columns.switch<csr.Ccolumns | undefined>({
						yes: ($) => $.properties.first.ref,
						no: undefined,
					});
				},
				order_constraint: "column order",
			},
			"has selected entries": {
				states: {
					no: {
						binding: { properties: {} },
					},
					yes: {
						binding: {
							properties: {
								"selected entries": {
									entry: {
										binding: {
											properties: {},
											bindings: {
												node: (implementation_context) => {
													const client_state = ensure(
														implementation_context.current_binding_context,
														csr.Cselected_entries
													);
													const destructor = new DestructorTree();
													const node = registerQueryEntry(client_state.properties.entry_status, destructor);
													client_state.properties.entry_status.onDestroy(() => destructor.destroy());
													return implementation_context.changeState({ new_binding_context: node });
												},
											},
											instruction_handlers: {
												delete: async (implementation_context: ImplementationVisitorContext) => {
													const client_state = ensure(
														implementation_context.current_binding_context,
														csr.Cselected_entries
													);
													switch (client_state.properties.is_editable.state.name) {
														case "no":
															break;
														case "yes":
															await deleteQueryEntry(client_state.properties.entry_status);
													}
												},
												deselect: (implementation_context: ImplementationVisitorContext) => {
													const client_state = ensure(
														implementation_context.current_binding_context,
														csr.Cselected_entries
													);
													deselectEntry(client_state);
												},
											},
										},
									},
								},
								"number of selected entries": {},
								"number of editable selected entries": {},
							},
						},
					},
				},
			},
			"can download files": {
				onContext: (context) => {
					const query = ensure(context.current_binding_context, csr.Cquery__client_state);
					reQuery.stopDelayingQuery(query);
					return context;
				},
				states: {
					no: { binding: { properties: {} } },
					yes: {
						binding: {
							properties: {},
							instruction_handlers: {
								"download all files": (implementation_context) => {
									const client_state = ensure(
										implementation_context.current_binding_context,
										csr.Cyes__can_download_files__query
									);
									fileUpload.downloadFilesFromQuery(client_state.parent);
								},
							},
						},
					},
				},
			},
			"has result": {
				onContext: (context) => {
					const query = ensure(context.current_binding_context, csr.Cquery__client_state);
					reQuery.stopDelayingQuery(query);
					return context;
				},
				states: {
					no: {
						binding: {
							properties: {},
						},
					},
					yes: {
						binding: {
							properties: {
								"amount of entries visible": {},
								"is empty": {
									states: {
										yes: { binding: { properties: {} } },
										no: {
											binding: {
												properties: {
													"result size": {
														states: {
															multiple: { binding: { properties: {} } },
															one: { binding: { properties: {} } },
														},
													},
												},
											},
										},
									},
								},
								"selected entries": {
									states: {
										all: { binding: { properties: {} } },
										some: { binding: { properties: {} } },
										none: { binding: { properties: {} } },
									},
								},
								entries: {
									entry: {
										binding: {
											properties: {},
											bindings: {
												entry: (implementation_context) => implementation_context,
											},
										},
									},
								},
								"has more entries than maximum": {
									states: {
										no: {
											binding: {
												properties: {},
											},
										},
										yes: {
											binding: {
												properties: {
													"can show all": {
														states: {
															no: { binding: { properties: {} } },
															yes: {
																binding: {
																	properties: {},
																	instruction_handlers: {
																		"show all": (implementation_context: ImplementationVisitorContext) => {
																			const client_state = ensure(
																				implementation_context.current_binding_context,
																				csr.Cyes__can_show_all
																			);
																			const query = client_state.parent.parent.parent;
																			query.properties.show_all.set("yes", {});
																			reQuery.execute(query);
																		},
																	},
																},
															},
														},
													},
												},
											},
										},
									},
								},
								"total amount of entries": {},
								"backend updates are available": {
									states: {
										no: {
											binding: {
												properties: {},
											},
										},
										yes: {
											binding: {
												properties: {},
											},
										},
									},
								},
							},
							instruction_handlers: {
								clear: (implementation_context) => {
									const query = ensure(implementation_context.current_binding_context, csr.Cyes__has_result);
									query.parent.properties.has_result.set("no", {});
								},
							},
						},
					},
				},
			},
			"entries are editable": {
				onContext: (implementation_context, destructor) => {
					const query = ensure(implementation_context.current_binding_context, csr.Cquery__client_state);
					onScalarValue(
						iQuery(query).entriesAreEditable,
						() => undefined,
						(scalar, subscription) =>
							destructor.onDestroy(() => {
								if (query.destroyed) return;
								scalar.unsubscribe(subscription);
							})
					);
					return implementation_context;
				},
				states: {
					no: { binding: { properties: {} } },
					yes: {
						binding: {
							properties: {
								"is importing": {
									states: {
										no: { binding: { properties: {} } },
										yes: { binding: { properties: {} } },
									},
								},
								"can create entry": {
									states: {
										no: { binding: { properties: {} } },
										yes: {
											binding: {
												properties: {},
												instruction_handlers: {
													"add entry": (implementation_context, view) => {
														const client_context = ensure(
															implementation_context.current_binding_context,
															csr.Cyes__can_create_entry__yes
														);
														add.query_entry(
															client_context,
															view.parent.properties.view.ref,
															view.properties.window.ref
														);
													},
													"add entry with key": (implementation_context, view, key) => {
														const client_context = ensure(
															implementation_context.current_binding_context,
															csr.Cyes__can_create_entry__yes
														);
														add.query_entry(
															client_context,
															view.parent.properties.view.ref,
															view.properties.window.ref,
															key
														);
													},
												},
											},
										},
									},
								},
							},
							instruction_handlers: {
								"import csv": async function (implementation_context: ImplementationVisitorContext, file_event: File) {
									const client_context = ensure(
										implementation_context.current_binding_context,
										csr.Cyes__entries_are_editable
									);
									await client_context.parent.properties.use_for.switch({
										query: async ($) => await csv_import.forQuery($, file_event),
										candidates: () => undefined,
									});
								},
							},
						},
					},
				},
			},
			"is busy querying": {
				states: {
					no: {
						binding: {
							properties: {
								"request status": {
									states: {
										success: { binding: { properties: {} } },
										failure: { binding: { properties: {} } },
									},
								},
							},
						},
					},
					yes: {
						binding: {
							properties: {
								"requery needed": {
									states: {
										no: {
											binding: {
												properties: {},
											},
										},
										yes: {
											binding: {
												properties: {},
											},
										},
									},
								},
							},
						},
					},
				},
			},
		},
		instruction_handlers: {
			"reset all filters": function (implementation_context: ImplementationVisitorContext) {
				const client_context = ensure(implementation_context.current_binding_context, csr.Cquery__client_state);
				queryFilter.resetFilters(client_context);
			},
			"remove all filters": function (implementation_context: ImplementationVisitorContext) {
				const client_context = ensure(implementation_context.current_binding_context, csr.Cquery__client_state);
				queryFilter.removeFilters(client_context);
			},
			refresh: function (implementation_context: ImplementationVisitorContext) {
				const client_context = ensure(implementation_context.current_binding_context, csr.Cquery__client_state);
				reQuery.execute(client_context);
			},
			"download as Excel": function (implementation_context: ImplementationVisitorContext) {
				const context = ensure(implementation_context.current_binding_context, csr.Cquery__client_state);
				context.properties.use_for.switch({
					query: function ($) {
						reports.download_ad_hoc_report($);
					},
					candidates: undefined,
				});
			},
			"download as Excel template": function (implementation_context: ImplementationVisitorContext) {
				const context = ensure(implementation_context.current_binding_context, csr.Cquery__client_state);
				context.properties.use_for.switch({
					query: function ($) {
						reports.download_ad_hoc_import_template($);
					},
					candidates: undefined,
				});
			},
		},
		bindings: {
			"text column": (implementation_context) => {
				const state = ensure(implementation_context.current_binding_context, csr.Ctext__type__cells);
				return implementation_context.switchBindingContext(state.inferences.column_type());
			},
			"context node": (implementation_context) => {
				const state = ensure(implementation_context.current_binding_context, csr.Cquery__client_state);
				const position = state.input.position();
				switch (position.variant.name) {
					case "node": {
						const query_definition = state.properties.definition.ref;
						switch (query_definition.properties.context.state.name) {
							case "node": {
								const node_context = query_definition.properties.context.state.node;
								switch (node_context.properties.switch_.state.name) {
									case "root": {
										return implementation_context.switchBindingContext(
											position.variant.definition.root.properties.root
										);
									}
									case "current":
										break;
								}
								break;
							}
							case "candidates":
								break;
						}
						return implementation_context.switchBindingContext(position.variant.definition);
					}
					case "navigable text property": {
						const node = position.variant.definition.parent.parent.parent.parent.parent;
						return implementation_context.switchBindingContext(node);
					}
				}
			},
		},
	},
	"query entry": {
		properties: {
			cells: {
				entry: {
					binding: {
						properties: {
							"column type": {
								states: {
									content: {
										binding: {
											properties: {},
										},
									},
									id: {
										binding: {
											properties: {},
										},
									},
								},
							},
							type: {
								states: {
									file: {
										binding: {
											properties: {
												"is set": {
													states: {
														no: {
															binding: {
																properties: {},
															},
														},
														yes: {
															binding: {
																properties: {
																	token: {},
																	extension: {},
																},
																instruction_handlers: {
																	"download file": function (implementation_context: ImplementationVisitorContext) {
																		const client_state = ensure(
																			implementation_context.current_binding_context,
																			csr.Cyes__is_set__file__type__cells
																		);
																		fileUpload.downloadFileFromQuery(client_state);
																	},
																},
															},
														},
													},
												},
											},
										},
									},
									number: {
										binding: {
											properties: {
												"is set": {
													states: {
														no: {
															binding: {
																properties: {},
															},
														},
														yes: {
															binding: {
																properties: {
																	number: {
																		onContext: (implementation_context) => {
																			const number_cell = ensure(
																				implementation_context.current_binding_context,
																				csr.Cyes__is_set__number__type__cells
																			).parent;
																			const numerical_type_properties = initializedNumericalTypeProperties(
																				number_cell.properties.numerical_type_properties
																			);
																			return implementation_context.changeState({
																				new_number_converter: makeNumberConverter(numerical_type_properties),
																			});
																		},
																	},
																	"textual representation": {},
																},
															},
														},
													},
												},
												unit: {
													onContext: (implementation_context) => {
														const client_state = ensure(
															implementation_context.current_binding_context,
															csr.Cnumber__type__cells
														);
														const numerical_type_properties = initializedNumericalTypeProperties(
															client_state.properties.numerical_type_properties
														);
														return implementation_context.changeState({
															new_binding_context: numerical_type_properties,
														});
													},
												},
												decimals: {
													onContext: (implementation_context) => {
														const client_state = ensure(
															implementation_context.current_binding_context,
															csr.Cnumber__type__cells
														);
														const numerical_type_properties = initializedNumericalTypeProperties(
															client_state.properties.numerical_type_properties
														);
														return implementation_context.changeState({
															new_binding_context: numerical_type_properties,
														});
													},
												},
											},
											bindings: {
												column: (implementation_context) => {
													const state = ensure(
														implementation_context.current_binding_context,
														csr.Cnumber__type__cells
													);
													return implementation_context.switchBindingContext(state.inferences.column_type());
												},
											},
										},
									},
									reference: {
										binding: {
											properties: {
												"is set": {
													states: {
														no: {
															binding: {
																properties: {},
															},
														},
														yes: {
															binding: {
																properties: {
																	reference: {},
																},
															},
														},
													},
												},
											},
										},
									},
									"state group": {
										binding: {
											properties: {
												"is set": {
													states: {
														no: {
															binding: {
																properties: {},
															},
														},
														yes: {
															binding: {
																properties: {
																	state: {},
																},
																bindings: {
																	style: (implementation_context) => {
																		const client_state = ensure(
																			implementation_context.current_binding_context,
																			csr.Cyes__is_set__state_group__type__cells
																		);
																		//setting the style is handled by updateQueryFromCollectionQueryResult.
																		return implementation_context.changeState({
																			new_binding_context: initializedStyle(client_state.properties.style),
																		});
																	},
																},
															},
														},
													},
												},
											},
										},
									},
									text: {
										binding: {
											properties: {
												"is set": {
													states: {
														no: {
															binding: {
																properties: {},
															},
														},
														yes: {
															binding: {
																properties: {
																	text: {},
																},
															},
														},
													},
												},
											},
										},
									},
									widget: {
										binding: {
											properties: {},
										},
									},
								},
							},
						},
					},
				},
				first_entry: (client_state) => {
					const cells_context = ensure(client_state, csr.Centries__yes__has_result);
					return cells_context.properties.has_cells.switch<csr.Ccells | undefined>({
						yes: ($) => $.properties.first.ref,
						no: undefined,
					});
				},
				order_constraint: "cell order",
			},
			"use for": {
				states: {
					query: {
						binding: {
							properties: {},
						},
					},
					candidates: {
						binding: {
							properties: {},
							instruction_handlers: {
								"select candidate": function (implementation_context: ImplementationVisitorContext) {
									const client_state = ensure(
										implementation_context.current_binding_context,
										csr.Ccandidates__use_for__entries
									);
									select_candidate(client_state);
									return referencesResolved();
								},
							},
						},
					},
				},
			},
			"is editable": {
				onContext: (implementation_context) => {
					const state = ensure(implementation_context.current_binding_context, csr.Centries__yes__has_result);
					checkEntryPermission(state);
					return implementation_context;
				},
				states: {
					no: {
						binding: {
							properties: {},
						},
					},
					yes: {
						binding: {
							properties: {},
							instruction_handlers: {
								"delete dictionary entry": async function (implementation_context: ImplementationVisitorContext) {
									const state = ensure(implementation_context.current_binding_context, csr.Cyes__is_editable__entries);
									await deleteQueryEntry(state.parent.properties.entry_status);
								},
							},
						},
					},
				},
			},
			"is selected": {
				states: {
					no: {
						binding: {
							instruction_handlers: {
								select: (implementation_context) => {
									const client_state = ensure(
										implementation_context.current_binding_context,
										csr.Cno__is_selected__entries
									);
									selectEntry(client_state);
								},
							},
							properties: {},
						},
					},
					yes: {
						binding: {
							instruction_handlers: {
								deselect: (implementation_context) => {
									const client_state = ensure(
										implementation_context.current_binding_context,
										csr.Cyes__is_selected__entries
									);
									deselectEntry(client_state.properties.selected_entry.ref);
									client_state.parent.properties.is_selected.set("no", {});
								},
							},
							properties: {},
						},
					},
				},
			},
			"is valid": {
				states: {
					no: { binding: { properties: {} } },
					yes: { binding: { properties: {} } },
				},
			},
		},
		bindings: {
			node: (implementation_context) => {
				const client_state = ensure(implementation_context.current_binding_context, csr.Centries__yes__has_result);
				const destructor = new DestructorTree();
				const node = registerQueryEntry(client_state.properties.entry_status, destructor);
				client_state.properties.entry_status.onDestroy(() => destructor.destroy());
				return implementation_context.changeState({ new_binding_context: node });
			},
			style: (implementation_context) => {
				const client_state = ensure(implementation_context.current_binding_context, csr.Centries__yes__has_result);
				//setting the style is handled by updateQueryFromCollectionQueryResult.
				return implementation_context.changeState({
					new_binding_context: initializedStyle(client_state.properties.style),
				});
			},
		},
		instruction_handlers: {
			"open entry": (implementation_context, view) => {
				const client_state = ensure(implementation_context.current_binding_context, csr.Centries__yes__has_result);
				open.entry(client_state, view.parent.properties.view.ref, view.properties.window.ref);
			},
		},
	},
	"query file": {
		properties: {
			"is set": {
				states: {
					no: {
						binding: {
							properties: {},
						},
					},
					yes: {
						binding: {
							properties: {
								extension: {},
								token: {},
							},
						},
					},
				},
			},
		},
	},
	"query stategroup column": {
		properties: {
			"has filter": {
				states: {
					no: {
						binding: {
							properties: {},
						},
					},
					yes: {
						binding: {
							properties: {
								"filter enabled": {
									states: {
										no: {
											binding: {
												properties: {},
												instruction_handlers: {
													"enable state group filter": function (implementation_context: ImplementationVisitorContext) {
														const state = ensure(
															implementation_context.current_binding_context,
															csr.Cno__filter_enabled
														);
														queryFilter.enableStateGroupColumn(state);
													},
												},
											},
										},
										yes: {
											binding: {
												properties: {},
												instruction_handlers: {
													"disable state group filter": function (
														implementation_context: ImplementationVisitorContext
													) {
														const state = ensure(
															implementation_context.current_binding_context,
															csr.Cyes__filter_enabled
														);
														queryFilter.disableStateGroupColumn(state);
													},
												},
											},
										},
									},
								},
								states: {
									entry: {
										binding: {
											properties: {
												name: {},
												"is selected": {
													states: {
														no: {
															binding: {
																properties: {},
																instruction_handlers: {
																	"set state filter": function (implementation_context: ImplementationVisitorContext) {
																		const state = ensure(
																			implementation_context.current_binding_context,
																			csr.Cno__is_selected__states__yes
																		);
																		queryFilter.setStateFilter(state);
																	},
																},
															},
														},
														yes: {
															binding: {
																properties: {},
																instruction_handlers: {
																	"unset state filter": function (
																		implementation_context: ImplementationVisitorContext
																	) {
																		const state = ensure(
																			implementation_context.current_binding_context,
																			csr.Cyes__is_selected__states__yes
																		);
																		queryFilter.unsetStateFilter(state);
																	},
																},
															},
														},
													},
												},
											},
										},
									},
								},
								"has default filter": {
									states: {
										no: {
											binding: {
												properties: {},
											},
										},
										yes: {
											binding: {
												properties: {
													// "filter": {}
												},
												instruction_handlers: {
													"reset filter": function (implementation_context: ImplementationVisitorContext) {
														const state = ensure(
															implementation_context.current_binding_context,
															csr.Cyes__has_default_filter__yes__has_filter__state_group
														);
														queryFilter.resetStateGroupFilter(state.parent);
													},
												},
											},
										},
									},
								},
							},
							instruction_handlers: {
								"remove filter": function (implementation_context: ImplementationVisitorContext) {
									const state = ensure(
										implementation_context.current_binding_context,
										csr.Cyes__has_filter__state_group
									);
									queryFilter.removeStateGroupFilter(state);
								},
							},
						},
					},
				},
			},
		},
	},
	"query stategroup": {
		properties: {
			"is set": {
				states: {
					no: {
						binding: {
							properties: {},
						},
					},
					yes: {
						binding: {
							properties: {
								state: {},
							},
							bindings: {
								style: (implementation_context) => {
									const client_state = ensure(
										implementation_context.current_binding_context,
										csr.Cyes__is_set__state_group__type__cells
									);
									//setting the style is handled by updateQueryFromCollectionQueryResult.
									return implementation_context.changeState({
										new_binding_context: initializedStyle(client_state.properties.style),
									});
								},
							},
						},
					},
				},
			},
		},
		bindings: {
			column: (implementation_context) => {
				const state = ensure(implementation_context.current_binding_context, csr.Cstate_group__type__cells);
				return implementation_context.switchBindingContext(state.inferences.column_type());
			},
		},
	},
	"query number column": {
		properties: {
			"has filter": {
				states: {
					no: {
						binding: {
							properties: {},
						},
					},
					yes: {
						binding: {
							properties: {
								"criteria is valid": {
									states: {
										no: {
											binding: {
												properties: {},
											},
										},
										yes: {
											binding: {
												properties: {
													criteria: {
														onContext: (implementation_context) => {
															const client_state = ensure(
																implementation_context.current_binding_context,
																csr.Cyes__criteria_is_valid__yes__has_filter
															);
															const numerical_type_properties = initializedNumericalTypeProperties(
																client_state.parent.properties.numerical_type_properties
															);
															evaluateNumericalTypeFilter(numerical_type_properties, client_state.parent);
															return implementation_context.changeState({
																new_number_converter: makeNumberConverter(numerical_type_properties),
															});
														},
													},
												},
											},
										},
									},
								},
								"filter set": {
									states: {
										no: {
											binding: {
												properties: {},
											},
										},
										yes: {
											binding: {
												properties: {},
											},
										},
									},
								},
								"filter range": {
									states: {
										"not available": { binding: { properties: {} } },
										no: {
											binding: {
												properties: {},
												instruction_handlers: {
													"enable range": (implementation_context) => {
														const client_state = ensure(
															implementation_context.current_binding_context,
															csr.Cno__filter_range
														);
														queryFilter.enableRange(client_state.parent);
													},
												},
											},
										},
										yes: {
											binding: {
												properties: {
													"criteria is valid": {
														states: {
															no: {
																binding: {
																	properties: {},
																},
															},
															yes: {
																binding: {
																	properties: {
																		criteria: {
																			onContext: (implementation_context) => {
																				const client_state = ensure(
																					implementation_context.current_binding_context,
																					csr.Cyes__criteria_is_valid__yes__filter_range
																				);
																				const numerical_type_properties = initializedNumericalTypeProperties(
																					client_state.parent.parent.properties.numerical_type_properties
																				);
																				return implementation_context.changeState({
																					new_number_converter: makeNumberConverter(numerical_type_properties),
																				});
																			},
																		},
																	},
																},
															},
														},
													},
													operator: {
														states: {
															"greater than": {
																binding: {
																	properties: {
																		"or equal to": {
																			states: {
																				no: {
																					binding: {
																						properties: {},
																						instruction_handlers: {
																							set: (implementation_context) => {
																								const client_state = ensure(
																									implementation_context.current_binding_context,
																									csr.Cno__or_equal_to__greater_than
																								);
																								queryFilter.rangeGreaterThanOrEqualTo(client_state.parent);
																							},
																						},
																					},
																				},
																				yes: {
																					binding: {
																						properties: {},
																						instruction_handlers: {
																							unset: (implementation_context) => {
																								const client_state = ensure(
																									implementation_context.current_binding_context,
																									csr.Cyes__or_equal_to__greater_than
																								);
																								queryFilter.rangeGreaterThan(client_state.parent);
																							},
																						},
																					},
																				},
																			},
																		},
																	},
																},
															},
															"smaller than": {
																binding: {
																	properties: {
																		"or equal to": {
																			states: {
																				no: {
																					binding: {
																						properties: {},
																						instruction_handlers: {
																							set: (implementation_context) => {
																								const client_state = ensure(
																									implementation_context.current_binding_context,
																									csr.Cno__or_equal_to__smaller_than
																								);
																								queryFilter.rangeSmallerThanOrEqualTo(client_state.parent);
																							},
																						},
																					},
																				},
																				yes: {
																					binding: {
																						properties: {},
																						instruction_handlers: {
																							unset: (implementation_context) => {
																								const client_state = ensure(
																									implementation_context.current_binding_context,
																									csr.Cyes__or_equal_to__smaller_than
																								);
																								queryFilter.rangeSmallerThan(client_state.parent);
																							},
																						},
																					},
																				},
																			},
																		},
																	},
																},
															},
														},
													},
												},
												instruction_handlers: {
													"disable range": (implementation_context) => {
														const client_state = ensure(
															implementation_context.current_binding_context,
															csr.Cyes__filter_range
														);
														queryFilter.disableRange(client_state.parent);
													},
													"filter number criteria": (implementation_context, value: number) => {
														const state = ensure(
															implementation_context.current_binding_context,
															csr.Cyes__filter_range
														);
														const numerical_type_properties = initializedNumericalTypeProperties(
															state.parent.properties.numerical_type_properties
														);
														queryFilter.numberColumnRange(
															state,
															makeNumberConverter(numerical_type_properties).from(value)
														);
													},
												},
											},
										},
									},
								},
								"has default filter": {
									states: {
										no: {
											binding: {
												properties: {},
											},
										},
										yes: {
											binding: {
												properties: {},
												instruction_handlers: {
													"reset filter": function (implementation_context: ImplementationVisitorContext) {
														const state = ensure(
															implementation_context.current_binding_context,
															csr.Cyes__has_default_filter__yes__has_filter__number
														);
														queryFilter.resetNumberFilter(state.parent);
													},
												},
											},
										},
									},
								},
								"representation type": {
									onContext: (implementation_context) => {
										const number_filter = ensure(
											implementation_context.current_binding_context,
											csr.Cyes__has_filter__number
										);
										return implementation_context.changeState({
											new_binding_context:
												number_filter.parent.inferences.number_type().properties.number.ref.properties.numerical_type
													.ref,
										});
									},
									states: {
										date: {
											binding: {
												properties: {},
											},
										},
										"date and time": {
											binding: {
												properties: {},
											},
										},
										model: {
											binding: {
												properties: {
													style: {
														states: {
															decimal: {
																binding: {
																	properties: {},
																},
															},
															currency: {
																binding: {
																	properties: {},
																},
															},
															scientific: {
																binding: {
																	properties: {},
																},
															},
															engineering: {
																binding: {
																	properties: {},
																},
															},
														},
													},
												},
											},
										},
										duration: {
											binding: {
												properties: {
													unit: {
														states: {
															hours: {
																binding: {
																	properties: {},
																},
															},
															minutes: {
																binding: {
																	properties: {},
																},
															},
															seconds: {
																binding: {
																	properties: {},
																},
															},
														},
													},
												},
											},
										},
									},
								},
								"operator selected": {
									states: {
										no: {
											binding: {
												properties: {},
											},
										},
										yes: {
											binding: {
												properties: {
													operator: {
														states: {
															"equal to": {
																binding: {
																	properties: {},
																},
															},
															"greater than": {
																binding: {
																	properties: {},
																},
															},
															"greater than or equal to": {
																binding: {
																	properties: {},
																},
															},
															"smaller than": {
																binding: {
																	properties: {},
																},
															},
															"smaller than or equal to": {
																binding: {
																	properties: {},
																},
															},
														},
													},
												},
											},
										},
									},
								},
								unit: {
									onContext: (implementation_context) => {
										const client_state = ensure(
											implementation_context.current_binding_context,
											csr.Cyes__has_filter__number
										);
										const numerical_type_properties = initializedNumericalTypeProperties(
											client_state.properties.numerical_type_properties
										);
										evaluateNumericalTypeFilter(numerical_type_properties, client_state);
										return implementation_context.changeState({
											new_binding_context: numerical_type_properties,
										});
									},
								},
								decimals: {
									onContext: (implementation_context) => {
										const client_state = ensure(
											implementation_context.current_binding_context,
											csr.Cyes__has_filter__number
										);
										const numerical_type_properties = initializedNumericalTypeProperties(
											client_state.properties.numerical_type_properties
										);
										evaluateNumericalTypeFilter(numerical_type_properties, client_state);
										return implementation_context.changeState({
											new_binding_context: numerical_type_properties,
										});
									},
								},
							},
							instruction_handlers: {
								"select equal to": (implementation_context) => {
									const state = ensure(implementation_context.current_binding_context, csr.Cyes__has_filter__number);
									queryFilter.numberColumnOperator(state, "equal to");
								},
								"select greater than": (implementation_context) => {
									const state = ensure(implementation_context.current_binding_context, csr.Cyes__has_filter__number);
									queryFilter.numberColumnOperator(state, "greater than");
								},
								"select greater than or equal to": (implementation_context) => {
									const state = ensure(implementation_context.current_binding_context, csr.Cyes__has_filter__number);
									queryFilter.numberColumnOperator(state, "greater than or equal to");
								},
								"select smaller than": (implementation_context) => {
									const state = ensure(implementation_context.current_binding_context, csr.Cyes__has_filter__number);
									queryFilter.numberColumnOperator(state, "smaller than");
								},
								"select smaller than or equal to": (implementation_context) => {
									const state = ensure(implementation_context.current_binding_context, csr.Cyes__has_filter__number);
									queryFilter.numberColumnOperator(state, "smaller than or equal to");
								},
								"filter number criteria": function (
									implementation_context: ImplementationVisitorContext,
									value: number
								) {
									const state = ensure(implementation_context.current_binding_context, csr.Cyes__has_filter__number);
									const numerical_type_properties = initializedNumericalTypeProperties(
										state.properties.numerical_type_properties
									);
									evaluateNumericalTypeFilter(numerical_type_properties, state);
									queryFilter.numberColumn(state, makeNumberConverter(numerical_type_properties).from(value));
								},
								"remove filter": function (implementation_context: ImplementationVisitorContext) {
									const state = ensure(implementation_context.current_binding_context, csr.Cyes__has_filter__number);
									queryFilter.removeNumberFilter(state);
								},
							},
						},
					},
				},
			},
			summarize: {
				onContext: (implementation_context) => {
					const number_column = ensure(implementation_context.current_binding_context, csr.Cnumber__type__columns);
					return implementation_context.changeState({
						new_binding_context: number_column.inferences.number_type().properties.number.ref,
					});
				},
				states: {
					no: {
						binding: {
							properties: {},
						},
					},
					total: {
						binding: {
							properties: {},
						},
					},
				},
			},
		},
	},
	"query number": {
		properties: {
			"is set": {
				states: {
					no: {
						binding: {
							properties: {},
						},
					},
					yes: {
						binding: {
							properties: {
								number: {
									onContext: (implementation_context) => {
										const client_state = ensure(
											implementation_context.current_binding_context,
											csr.Cyes__is_set__number__type__cells
										);
										const numerical_type_properties = initializedNumericalTypeProperties(
											client_state.parent.properties.numerical_type_properties
										);
										return implementation_context.changeState({
											new_number_converter: makeNumberConverter(numerical_type_properties),
										});
									},
								},
							},
						},
					},
				},
			},
			unit: {
				onContext: (implementation_context) => {
					const client_state = ensure(implementation_context.current_binding_context, csr.Cnumber__type__cells);
					const numerical_type_properties = initializedNumericalTypeProperties(
						client_state.properties.numerical_type_properties
					);
					return implementation_context.changeState({ new_binding_context: numerical_type_properties });
				},
			},
			decimals: {
				onContext: (implementation_context) => {
					const client_state = ensure(implementation_context.current_binding_context, csr.Cnumber__type__cells);
					const numerical_type_properties = initializedNumericalTypeProperties(
						client_state.properties.numerical_type_properties
					);
					return implementation_context.changeState({ new_binding_context: numerical_type_properties });
				},
			},
		},
		bindings: {
			column: (implementation_context) => {
				const state = ensure(implementation_context.current_binding_context, csr.Cnumber__type__cells);
				return implementation_context.switchBindingContext(state.inferences.column_type());
			},
		},
	},
	"query text": {
		properties: {
			"is set": {
				states: {
					no: {
						binding: {
							properties: {},
						},
					},
					yes: {
						binding: {
							properties: {
								text: {},
							},
						},
					},
				},
			},
		},
		bindings: {
			"query text column": (implementation_context) => {
				const state = ensure(implementation_context.current_binding_context, csr.Ctext__type__cells);
				return implementation_context.switchBindingContext(state.inferences.column_type());
			},
		},
	},
	"state group": {
		properties: {
			initialized: {
				states: {
					no: {
						binding: {
							properties: {},
						},
					},
					yes: {
						binding: {
							properties: {
								"state in backend": {},
							},
							instruction_handlers: {
								revert: function (implementation_context: ImplementationVisitorContext) {
									const client_state = ensure(
										implementation_context.current_binding_context,
										csr.Cyes__initialized__state_group
									);
									iStategroup(client_state.parent).discard();
								},
							},
						},
					},
				},
			},
			"is editable": {
				states: {
					no: {
						binding: {
							properties: {},
						},
					},
					yes: {
						binding: {
							properties: {
								"edit mode": {
									states: {
										off: {
											binding: {
												properties: {},
												instruction_handlers: {
													"switch on": (implementation_context) => {
														const client_state = ensure(
															implementation_context.current_binding_context,
															csr.Coff__edit_mode__yes__is_editable__state_group
														);
														client_state.parent.properties.edit_mode.set("on", {});
													},
												},
											},
										},
										on: {
											binding: {
												properties: {},
												instruction_handlers: {
													"switch off": (implementation_context) => {
														const client_state = ensure(
															implementation_context.current_binding_context,
															csr.Con__edit_mode__yes__is_editable__state_group
														);
														client_state.parent.properties.edit_mode.set("off", {});
													},
												},
											},
										},
									},
								},
							},
						},
					},
				},
			},
			"is modified": {
				states: {
					no: {
						binding: {
							properties: {},
						},
					},
					yes: {
						binding: {
							properties: {},
						},
					},
				},
			},
			"is set": {
				states: {
					no: {
						binding: {
							properties: {},
						},
					},
					yes: {
						binding: {
							properties: {},
							bindings: {
								state: (implementation_context) => {
									const client_state = ensure(
										implementation_context.current_binding_context,
										csr.Cyes__is_set__state_group__type__property
									);
									return implementation_context.changeState({
										new_binding_context: client_state.properties.state.ref,
									});
								},
							},
						},
					},
				},
			},
			"is valid": {
				states: {
					no: {
						binding: {
							properties: {
								"invalid rules": {
									states: {
										no: { binding: { properties: {} } },
										yes: { binding: { properties: {} } },
									},
								},
								"no state selected": {
									states: {
										no: { binding: { properties: {} } },
										yes: { binding: { properties: {} } },
									},
								},
							},
						},
					},
					yes: {
						binding: {
							properties: {},
						},
					},
				},
			},
		},
		instruction_handlers: {
			reset: function (implementation_context: ImplementationVisitorContext) {
				const client_state = ensure(implementation_context.current_binding_context, csr.Cstate_group__type__property);
				iStategroup(client_state).discard();
			},
		},
	},
	state: {
		bindings: {
			node: function (implementation_context: ImplementationVisitorContext): ImplementationVisitorContext {
				const client_state = ensure(
					implementation_context.current_binding_context,
					csr.Cstates__state_group__type__property
				);
				const new_client_state = client_state.properties.node;
				return implementation_context.changeState({ new_binding_context: new_client_state });
			},
			style: (implementation_context) => {
				const client_state = ensure(
					implementation_context.current_binding_context,
					csr.Cstates__state_group__type__property
				);
				const style = initializedStyle(client_state.properties.style);
				const ui = client_state.key.ref.properties.ui;
				switch (ui.properties.has_style.state.name) {
					case "no":
						break;
					case "yes": {
						const $ = ui.properties.has_style.state.node;
						evaluateStyle(style, $.properties.style_expression, client_state.properties.node);
						break;
					}
					default:
						unexpectedState(ui.properties.has_style.state);
				}

				return implementation_context.changeState({ new_binding_context: style });
			},
		},
		properties: {
			"create permitted": {
				states: {
					no: {
						binding: {
							properties: {},
						},
					},
					yes: {
						binding: {
							properties: {},
							instruction_handlers: {
								"set state": function (implementation_context: ImplementationVisitorContext) {
									const client_state = ensure(
										implementation_context.current_binding_context,
										csr.Cyes__create_permitted
									);
									iState(client_state.parent).select("user");
								},
							},
						},
					},
				},
			},
			"is selected": {
				states: {
					no: {
						binding: {
							properties: {},
						},
					},
					yes: {
						binding: {
							properties: {
								"all rules are valid": {
									states: {
										no: {
											binding: {
												properties: {
													"violated rule": {},
												},
											},
										},
										yes: { binding: { properties: {} } },
									},
								},
							},
						},
					},
				},
			},
		},
	},
	rule: {
		properties: {
			"is valid": {
				states: {
					no: { binding: { properties: {} } },
					yes: { binding: { properties: {} } },
				},
			},
			status: {
				onContext: (implmentation_context, destructor) => {
					const rule = ensure(implmentation_context.current_binding_context, csr.Crules);
					onScalarValue(
						Rule.node(rule),
						() => undefined,
						(scalar, subscription) => destructor.onDestroy(() => scalar.unsubscribe(subscription))
					);
					return implmentation_context.changeState({
						new_binding_context: rule.properties.resolve_status,
					});
				},
				states: {
					"is busy resolving": { binding: { properties: {} } },
					resolved: {
						binding: {
							properties: {},
							bindings: {
								node: (implementation_context) => {
									const client_state = ensure(implementation_context.current_binding_context, csr.Cresolved__status);
									const node = getReferencedNode(client_state);
									return implementation_context.changeState({
										new_binding_context: node.input.entity().output.node(),
									});
								},
							},
							instruction_handlers: {
								"open entity": (implementation_context, view) => {
									const binding_context = ensure(implementation_context.current_binding_context, csr.Cresolved__status);
									open.state_rule(
										binding_context.parent.input.resolvable().cast("rule"),
										view.parent.properties.view.ref,
										view.properties.window.ref
									);
								},
							},
						},
					},
					"failed to resolve": { binding: { properties: {} } },
					unresolved: { binding: { properties: {} } },
				},
			},
		},
	},
	"query text column": {
		properties: {
			"has filter": {
				states: {
					no: {
						binding: {
							properties: {},
						},
					},
					yes: {
						binding: {
							properties: {
								value: {},
								"filter set": {
									states: {
										no: {
											binding: {
												properties: {},
											},
										},
										yes: {
											binding: {
												properties: {},
											},
										},
									},
								},
								"has default filter": {
									states: {
										no: {
											binding: {
												properties: {},
											},
										},
										yes: {
											binding: {
												properties: {
													// "value": {}
												},
												instruction_handlers: {
													"reset filter": function (implementation_context: ImplementationVisitorContext) {
														const state = ensure(
															implementation_context.current_binding_context,
															csr.Cyes__has_default_filter__yes__has_filter__text
														);
														queryFilter.resetTextFilter(state.parent);
													},
												},
											},
										},
									},
								},
							},
							instruction_handlers: {
								"remove filter": function (implementation_context: ImplementationVisitorContext) {
									const state = ensure(implementation_context.current_binding_context, csr.Cyes__has_filter__text);
									queryFilter.removeTextFilter(state);
								},
								"set text contains": function (implementation_context: ImplementationVisitorContext, event) {
									const state = ensure(implementation_context.current_binding_context, csr.Cyes__has_filter__text);
									queryFilter.textColumn(state, event, "contains");
								},
								"set text equals": function (implementation_context: ImplementationVisitorContext, event) {
									const state = ensure(implementation_context.current_binding_context, csr.Cyes__has_filter__text);
									queryFilter.textColumn(state, event, "equals");
								},
								"set text starts with": function (implementation_context: ImplementationVisitorContext, event) {
									const state = ensure(implementation_context.current_binding_context, csr.Cyes__has_filter__text);
									queryFilter.textColumn(state, event, "starts with");
								},
								"set text ends with": function (implementation_context: ImplementationVisitorContext, event) {
									const state = ensure(implementation_context.current_binding_context, csr.Cyes__has_filter__text);
									queryFilter.textColumn(state, event, "ends with");
								},
							},
						},
					},
				},
			},
		},
	},
	text: {
		properties: {
			"backend known": {
				states: {
					no: {
						binding: {
							properties: {},
						},
					},
					yes: {
						binding: {
							properties: {
								value: {},
							},
							instruction_handlers: {
								"mail password": (implementation_context) => {
									const client_state = ensure(
										implementation_context.current_binding_context,
										csr.Cyes__backend_known__text
									);
									mailPasswordToken(client_state.parent);
								},
								"copy password to clipboard": (implementation_context) => {
									const client_state = ensure(
										implementation_context.current_binding_context,
										csr.Cyes__backend_known__text
									);
									copyPasswordTokenToClipboard(client_state.parent);
								},
								revert: function (implementation_context: ImplementationVisitorContext) {
									const client_state = ensure(
										implementation_context.current_binding_context,
										csr.Cyes__backend_known__text
									);
									iText(client_state.parent).discard();
								},
							},
						},
					},
				},
			},
			"is editable": {
				states: {
					no: {
						binding: {
							properties: {},
						},
					},
					yes: {
						binding: {
							properties: {
								modified: {
									states: {
										no: {
											binding: {
												properties: {},
											},
										},
										yes: {
											binding: {
												properties: {
													value: {},
												},
											},
										},
									},
								},
								"edit mode": {
									states: {
										off: {
											binding: {
												properties: {},
												instruction_handlers: {
													"switch on": (implementation_context) => {
														const client_state = ensure(
															implementation_context.current_binding_context,
															csr.Coff__edit_mode__yes__is_editable__text
														);
														client_state.parent.properties.edit_mode.set("on", {});
													},
												},
											},
										},
										on: {
											binding: {
												properties: {},
												instruction_handlers: {
													"switch off": (implementation_context) => {
														const client_state = ensure(
															implementation_context.current_binding_context,
															csr.Con__edit_mode__yes__is_editable__text
														);
														client_state.parent.properties.edit_mode.set("off", {});
													},
												},
											},
										},
									},
								},
							},
							instruction_handlers: {
								"reset password": (implementation_context) => {
									const client_state = ensure(
										implementation_context.current_binding_context,
										csr.Cyes__is_editable__text
									);
									resetPassword(client_state.parent);
								},
							},
						},
					},
				},
			},
			"is valid": {
				states: {
					no: {
						binding: {
							properties: {
								"invalid rules": {
									states: {
										no: { binding: { properties: {} } },
										yes: { binding: { properties: {} } },
									},
								},
								"key is not unique": {
									states: {
										no: { binding: { properties: {} } },
										yes: { binding: { properties: {} } },
									},
								},
								"reference not resolved": {
									states: {
										no: { binding: { properties: {} } },
										yes: { binding: { properties: {} } },
									},
								},
								"referenced node not valid": {
									states: {
										no: { binding: { properties: {} } },
										yes: { binding: { properties: {} } },
									},
								},
								"text does not match pattern": {
									states: {
										no: { binding: { properties: {} } },
										yes: {
											binding: {
												properties: {
													pattern: {},
												},
											},
										},
									},
								},
							},
						},
					},
					yes: { binding: { properties: {} } },
				},
			},
			navigable: {
				states: {
					no: { binding: { properties: {} } },
					yes: {
						binding: {
							properties: {
								status: {
									onContext: (implementation_context, destructor) => {
										const reference = ensure(implementation_context.current_binding_context, csr.Cyes__navigable);
										const status = iReference(reference).status;
										const subscription = status.subscribe({ update: () => undefined });
										destructor.onDestroy(() => status.unsubscribe(subscription));
										return implementation_context.changeState({
											new_binding_context: reference.properties.resolve_status,
										});
									},
									states: {
										"is busy resolving": { binding: { properties: {} } },
										resolved: {
											binding: {
												properties: {},
												instruction_handlers: {
													"open reference": (implementation_context, view) => {
														const binding_context = ensure(
															implementation_context.current_binding_context,
															csr.Cresolved__status
														);
														open.reference(
															binding_context.parent.input.resolvable().cast("reference"),
															view.parent.properties.view.ref,
															view.properties.window.ref
														);
													},
												},
												bindings: {
													node: (implementation_context) => {
														const client_state = ensure(
															implementation_context.current_binding_context,
															csr.Cresolved__status
														);
														const node = getReferencedNode(client_state);
														return implementation_context.changeState({
															new_binding_context: node.input.entity().output.node(),
														});
													},
												},
											},
										},
										"failed to resolve": { binding: { properties: {} } },
										unresolved: { binding: { properties: {} } },
									},
								},
							},
						},
					},
				},
			},
			"is set": {
				states: {
					no: { binding: { properties: {} } },
					yes: {
						binding: {
							properties: {
								text: {},
							},
						},
					},
				},
			},
			"is key": {
				states: {
					no: { binding: { properties: {} } },
					yes: {
						binding: {
							properties: {
								"key unique": {
									states: {
										no: { binding: { properties: {} } },
										yes: { binding: { properties: {} } },
									},
								},
							},
						},
					},
				},
			},
			"validation result": {
				states: {
					failure: { binding: { properties: {} } },
					success: { binding: { properties: {} } },
				},
			},
		},
		instruction_handlers: {
			reset: (implementation_context) => {
				const client_state = ensure(implementation_context.current_binding_context, csr.Ctext__type__property);
				if (isPasswordProperty(client_state.inferences.text_type())) {
					const entry = client_state.parent.parent.parent.input.entity().cast("entry");
					entry.properties.key.ref.properties.is_editable.switch({
						no: () => iText(client_state).discard(),
						yes: ($) => {
							$.properties.modified.switch({
								no: () => iText(client_state).discard(),
								yes: () => {
									messages.addMessage("warning", "Cannot reset password.", { body: "The username changed." });
								},
							});
						},
					});
				} else {
					iText(client_state).discard();
				}
			},
			"update text": function (implementation_context: ImplementationVisitorContext, event) {
				const client_state = ensure(implementation_context.current_binding_context, csr.Ctext__type__property);
				if (isPasswordProperty(client_state.inferences.text_type())) {
					update.password(client_state.properties.navigable.cast("no"), event);
				} else {
					iText(client_state).update(event, "user");
				}
			},
		},
	},
	view: {
		bindings: {
			entity: function (implementation_context: ImplementationVisitorContext): ImplementationVisitorContext {
				const client_state = ensure(implementation_context.current_binding_context, csr.Copen_views);
				const new_client_state = client_state.properties.view_context.output.result_node();
				return implementation_context.changeState({ new_binding_context: new_client_state });
			},
			node: function (implementation_context: ImplementationVisitorContext): ImplementationVisitorContext {
				const client_state = implementation_context.current_binding_context;
				if (client_state instanceof csr.Copen_views) {
					const new_client_state = client_state.properties.view_context.output.result_node();
					return implementation_context.changeState({ new_binding_context: new_client_state });
				} else if (client_state instanceof csr.Cnode) {
					//for inline views
					return implementation_context;
				} else {
					throw new Error("Expected current binding context to be of type Copen_views or Cnode.");
				}
			},
		},
		properties: {
			"is active view": {
				states: {
					no: {
						binding: {
							properties: {},
						},
					},
					yes: {
						binding: {
							properties: {},
						},
					},
				},
			},
			"action active": {
				states: {
					no: { binding: { properties: {} } },
					yes: {
						binding: {
							properties: {
								"can finish step": {
									states: {
										no: { binding: { properties: {} } },
										yes: {
											binding: {
												properties: {},
												instruction_handlers: {
													"finish current step": (implementation_context) => {
														const client_state = ensure(
															implementation_context.current_binding_context,
															csr.Cyes__can_finish_step
														);
														finishAction(client_state.parent);
													},
												},
											},
										},
									},
								},
								"last step": {
									states: {
										no: { binding: { properties: {} } },
										yes: { binding: { properties: {} } },
									},
								},
							},
							instruction_handlers: {
								"cancel action": (implementation_context) => {
									const client_state = ensure(implementation_context.current_binding_context, csr.Cyes__action_active);
									cancelAction(client_state);
								},
							},
						},
					},
				},
			},
		},
		instruction_handlers: {
			"close view": function (implementation_context: ImplementationVisitorContext) {
				const client_state = ensure(implementation_context.current_binding_context, csr.Copen_views);
				Window.getWindowInstance(client_state.parent.key.entry).close_view(client_state);
			},
			"copy link to clipboard": function (implementation_context: ImplementationVisitorContext) {
				const client_state = ensure(implementation_context.current_binding_context, csr.Copen_views);
				deeplink.copy_link_to_clipboard(client_state);
			},
			"open in new window": function (implementation_context: ImplementationVisitorContext) {
				const client_state = ensure(implementation_context.current_binding_context, csr.Copen_views);
				deeplink.view_in_new_window(client_state);
			},
		},
	},
	report: {
		properties: {
			"is valid": {
				onContext: (implementation_context) =>
					implementation_context.changeState({
						new_binding_context: reports.initializedReport(
							ensure(implementation_context.current_binding_context, csr.Creport_types__node)
						).properties.parameters,
					}),
				states: {
					yes: { binding: { properties: {} } },
					no: { binding: { properties: {} } },
				},
			},
			templates: {
				onContext: (implementation_context) =>
					implementation_context.changeState({
						new_binding_context: reports.initializedReport(
							ensure(implementation_context.current_binding_context, csr.Creport_types__node)
						),
					}),
				entry: {
					binding: {
						properties: {},
						instruction_handlers: {
							download: (implementation_context) => {
								const client_state = ensure(implementation_context.current_binding_context, csr.Ctemplates);
								reports.download_report(client_state.parent, client_state.key);
							},
						},
					},
				},
			},
		},
	},
	"report number parameter": {
		properties: {
			"is valid": {
				states: {
					yes: { binding: { properties: {} } },
					no: { binding: { properties: {} } },
				},
			},
			"is set": {
				states: {
					yes: {
						binding: {
							properties: {
								value: {},
							},
						},
					},
					no: { binding: { properties: {} } },
				},
			},
			unit: {
				onContext: (implementation_context) => {
					const client_state = ensure(implementation_context.current_binding_context, csr.Cnumber__type__parameters);
					const numerical_type_properties = initializedNumericalTypeProperties(
						client_state.properties.numerical_type_properties
					);
					//TODO: evaluateNumericalType(numerical_type_properties, client_state.inferences.number_type().inferences.number_type(), client_state.parent.parent.parent);
					return implementation_context.changeState({ new_binding_context: numerical_type_properties });
				},
			},
			decimals: {
				onContext: (implementation_context) => {
					const client_state = ensure(implementation_context.current_binding_context, csr.Cnumber__type__parameters);
					const numerical_type_properties = initializedNumericalTypeProperties(
						client_state.properties.numerical_type_properties
					);
					//TODO: evaluateNumericalType(numerical_type_properties, client_state.inferences.number_type(), client_state.parent.parent.parent);
					return implementation_context.changeState({ new_binding_context: numerical_type_properties });
				},
			},
		},
		instruction_handlers: {
			"set number": (implementation_context, value) => {
				update.reportNumberParameter(
					ensure(implementation_context.current_binding_context, csr.Cnumber__type__parameters),
					value
				);
			},
		},
	},
	"report text parameter": {
		properties: {
			"is valid": {
				states: {
					yes: { binding: { properties: {} } },
					no: { binding: { properties: {} } },
				},
			},
			"is set": {
				states: {
					yes: {
						binding: {
							properties: {
								value: {},
							},
						},
					},
					no: { binding: { properties: {} } },
				},
			},
		},
		instruction_handlers: {
			"update text": (implementation_context, value) => {
				update.reportTextParameter(
					ensure(implementation_context.current_binding_context, csr.Ctext__type__parameters),
					value
				);
			},
		},
	},
	style: {
		properties: {
			"has style": {
				states: {
					no: { binding: { properties: {} } },
					yes: {
						binding: {
							properties: {
								type: {
									states: {
										color: {
											binding: {
												properties: {
													value: {},
												},
											},
										},
										fixed: {
											binding: {
												properties: {
													style: {
														states: {
															foreground: { binding: { properties: {} } },
															background: { binding: { properties: {} } },
															brand: { binding: { properties: {} } },
															link: { binding: { properties: {} } },
															accent: { binding: { properties: {} } },
															success: { binding: { properties: {} } },
															warning: { binding: { properties: {} } },
															error: { binding: { properties: {} } },
														},
													},
												},
											},
										},
									},
								},
							},
						},
					},
				},
			},
		},
	},
};

const max_serializable_julian_date = 102440587;
const min_serializable_julian_date = -97559413;
const max_serializable_julian_time = 8850866716800;
const min_serializable_julian_time = -8429133283200;

function julianDateInRange(value: number) {
	return value <= max_serializable_julian_date && value >= min_serializable_julian_date;
}

function julianTimeInRange(value: number) {
	return value <= max_serializable_julian_time && value >= min_serializable_julian_time;
}

export const formatters: Formatters = {
	date: function (value: number) {
		if (julianDateInRange(value)) {
			return julian_date_2_js_date(value).toLocaleDateString();
		}
		return "out of range";
	},
	"date and time": function (value: number) {
		if (julianTimeInRange(value)) {
			return julian_datetime_2_js_date(value).toLocaleString();
		}
		return "out of range";
	},
	"HTML date and time": function (value: number) {
		if (julianTimeInRange(value)) {
			return julian_datetime_2_gregorian_datetime(value).htmlformat();
		}
		return "out of range";
	},
	"duration in hours": function (value: number) {
		return serializeHours(value);
	},
	"duration in minutes": function (value: number) {
		return serializeMinutes(value);
	},
	"duration in seconds": function (value: number) {
		return serializeSeconds(value);
	},
	"to color": function (value: string) {
		return to_color(value);
	},
	"url encode": (value) => encodeURIComponent(value),
};

export const transformers: Transformers = {
	"julian date to JS date": function (value: number) {
		if (julianDateInRange(value)) {
			return julian_date_2_js_date(value).getTime();
		}
		return NaN;
	},
	"julian date time to JS date": function (value: number) {
		if (julianTimeInRange(value)) {
			return julian_datetime_2_js_date(value).getTime();
		}
		return NaN;
	},
	"JS date to julian date": function (value: number) {
		return jsdate_2_julian_date(new Date(value));
	},
	"JS date to julian date and time": function (value: number) {
		return jsdate_2_julian_datetime(new Date(value));
	},
	"HTML date to julian date": function (value: string) {
		return jsdate_2_julian_date(new Date(value));
	},
	"HTML date time to julian date time": function (value: string) {
		const parsed_date = parseHtmlDate(value);
		if (parsed_date) {
			return jsdate_2_julian_datetime(parsed_date);
		} else {
			return NaN;
		}
	},
	"duration in seconds": function (value: string) {
		return parserNumber.parseSeconds(value);
	},
	"duration in minutes": function (value: string) {
		return parserNumber.parseMinutes(value);
	},
	"duration in hours": function (value: string) {
		return parserNumber.parseHours(value);
	},
};
